// Using string representations of ObjectIds for frontend mock data
export const mockUserId = "60a7b1c2d3e4f5a6b7c8d9e0";
export const mockPlatformId1 = "60a7b1c2d3e4f5a6b7c8d9e1"; // tavily
export const mockPlatformId2 = "60a7b1c2d3e4f5a6b7c8d9e2"; // openAI
export const mockPlatformId3 = "60a7b1c2d3e4f5a6b7c8d9e3"; // claude
export const mockPlatformId4 = "60a7b1c2d3e4f5a6b7c8d9e4"; // gemini
export const mockPlatformId5 = "60a7b1c2d3e4f5a6b7c8d9e5"; // elevenlabs
export const mockPlatformId6 = "680d7af400049e0d6ccacc73"; // huggingface
export const mockPlatformId7 = "60a7b1c2d3e4f5a6b7c8d9e7"; // replicate
export const mockPlatformId8 = "60a7b1c2d3e4f5a6b7c8d9e8"; // cohere
export const mockPlatformId9 = "60a7b1c2d3e4f5a6b7c8d9e9"; // stability
export const mockPlatformId10 = "60a7b1c2d3e4f5a6b7c8d9ea"; // mistral

// Mock platforms data (aligned with PlatformSchema fields relevant to frontend)
export const mockPlatforms = [
  {
    _id: mockPlatformId1,
    user_id: mockUserId,
    name: "tavily",
    apiEndpoint: "https://api.tavily.com",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "12 hours ago",
    currentPlan: "project",
    currentCost: 37956.75, // Scaled up from 542.25
  },
  {
    _id: mockPlatformId2,
    user_id: mockUserId,
    name: "openAI",
    apiEndpoint: "https://api.openai.com",
    costApiAvailable: true,
    dataExportFormat: "csv",
    isActive: true,
    lastSync: "1 day ago",
    currentPlan: "pay_as_you_go",
    currentCost: 27237.0, // Scaled up from 389.1
  },
  {
    _id: mockPlatformId3,
    user_id: mockUserId,
    name: "claude",
    apiEndpoint: "https://api.anthropic.com",
    costApiAvailable: true,
    dataExportFormat: "csv",
    isActive: true,
    lastSync: "2 days ago",
    currentPlan: "subscription_tiered",
    currentCost: 97237.0, // Scaled up from 1389.1
  },
  {
    _id: mockPlatformId4,
    user_id: mockUserId,
    name: "gemini",
    apiEndpoint: "https://generativelanguage.googleapis.com",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "6 hours ago",
    currentPlan: "pay_as_you_go",
    currentCost: 52696.0, // Scaled up from 752.8
  },
  {
    _id: mockPlatformId5,
    user_id: mockUserId,
    name: "elevenlabs",
    apiEndpoint: "https://api.elevenlabs.io",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "3 hours ago",
    currentPlan: "credit_based",
    currentCost: 29505.0, // Scaled up from 421.5
  },
  {
    _id: mockPlatformId6,
    user_id: mockUserId,
    name: "huggingface",
    apiEndpoint: "https://api-inference.huggingface.co",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "1 day ago",
    currentPlan: "subscription_tiered",
    currentCost: 10850.0, // Scaled up from 155.0
  },
  {
    _id: mockPlatformId7,
    user_id: mockUserId,
    name: "replicate",
    apiEndpoint: "https://api.replicate.com",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "4 hours ago",
    currentPlan: "pay_as_you_go",
    currentCost: 15420.0, // New platform
  },
  {
    _id: mockPlatformId8,
    user_id: mockUserId,
    name: "cohere",
    apiEndpoint: "https://api.cohere.ai",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "8 hours ago",
    currentPlan: "subscription_tiered",
    currentCost: 12840.0, // New platform
  },
  {
    _id: mockPlatformId9,
    user_id: mockUserId,
    name: "stability",
    apiEndpoint: "https://api.stability.ai",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "2 days ago",
    currentPlan: "credit_based",
    currentCost: 9780.0, // New platform
  },
  {
    _id: mockPlatformId10,
    user_id: mockUserId,
    name: "mistral",
    apiEndpoint: "https://api.mistral.ai",
    costApiAvailable: true,
    dataExportFormat: "json",
    isActive: true,
    lastSync: "5 hours ago",
    currentPlan: "pay_as_you_go",
    currentCost: 8730.0, // New platform
  },
];

// Mock summary data (aligned with DashboardController.getSummary output)
export const mockSummaryData = {
  totalPlatforms: mockPlatforms.length,
  currentMonthPlatformsCost: 50000,
  currentMonthUsage: {
    cost: 302251.75, // Sum of all platform costs
    tokens: 2100000000, // Scaled up from 30000000
    requests: 1400000, // Scaled up from 20000
  },
  percentChange: 18, // Adjusted from 12
  forecastedCost: 285000.0, // Scaled up from 3400.0
};

// Mock trends data - DAILY (24 hours) - scaled up with higher values and additional platforms
export const mockTrendsDaily = [
  {
    name: "2025-04-26 00:00",
    tavily: 2957.5,
    openAI: 2037.0,
    claude: 4606.0,
    gemini: 4067.0,
    elevenlabs: 2450.0,
    huggingface: 735.0,
    replicate: 875.0,
    cohere: 612.5,
    stability: 525.0,
    mistral: 455.0,
    cost: 19320.0,
    tokens: 105000000,
    requests: 84000,
  },
  {
    name: "2025-04-26 01:00",
    tavily: 2695.0,
    openAI: 2184.0,
    claude: 4340.0,
    gemini: 3885.0,
    elevenlabs: 2240.0,
    huggingface: 770.0,
    replicate: 805.0,
    cohere: 595.0,
    stability: 490.0,
    mistral: 420.0,
    cost: 18424.0,
    tokens: 101500000,
    requests: 80500,
  },
  {
    name: "2025-04-26 02:00",
    tavily: 2247.0,
    openAI: 1946.0,
    claude: 4081.0,
    gemini: 3514.0,
    elevenlabs: 1995.0,
    huggingface: 686.0,
    replicate: 735.0,
    cohere: 542.5,
    stability: 455.0,
    mistral: 385.0,
    cost: 16587.0,
    tokens: 91000000,
    requests: 73500,
  },
  {
    name: "2025-04-26 03:00",
    tavily: 1792.0,
    openAI: 1568.0,
    claude: 3479.0,
    gemini: 3017.0,
    elevenlabs: 1694.0,
    huggingface: 595.0,
    replicate: 665.0,
    cohere: 490.0,
    stability: 420.0,
    mistral: 350.0,
    cost: 14070.0,
    tokens: 77000000,
    requests: 64400,
  },
  {
    name: "2025-04-26 04:00",
    tavily: 1491.0,
    openAI: 1372.0,
    claude: 3024.0,
    gemini: 2695.0,
    elevenlabs: 1519.0,
    huggingface: 546.0,
    replicate: 612.5,
    cohere: 455.0,
    stability: 402.5,
    mistral: 315.0,
    cost: 12432.5,
    tokens: 66500000,
    requests: 58100,
  },
  {
    name: "2025-04-26 05:00",
    tavily: 1323.0,
    openAI: 1225.0,
    claude: 2702.0,
    gemini: 2464.0,
    elevenlabs: 1386.0,
    huggingface: 483.0,
    replicate: 560.0,
    cohere: 420.0,
    stability: 385.0,
    mistral: 280.0,
    cost: 11228.0,
    tokens: 60900000,
    requests: 54600,
  },
  {
    name: "2025-04-26 06:00",
    tavily: 1414.0,
    openAI: 1386.0,
    claude: 2821.0,
    gemini: 2653.0,
    elevenlabs: 1505.0,
    huggingface: 504.0,
    replicate: 595.0,
    cohere: 455.0,
    stability: 402.5,
    mistral: 297.5,
    cost: 12033.5,
    tokens: 64400000,
    requests: 56700,
  },
  {
    name: "2025-04-26 07:00",
    tavily: 1876.0,
    openAI: 1638.0,
    claude: 3213.0,
    gemini: 2961.0,
    elevenlabs: 1736.0,
    huggingface: 581.0,
    replicate: 647.5,
    cohere: 490.0,
    stability: 437.5,
    mistral: 332.5,
    cost: 13913.0,
    tokens: 75600000,
    requests: 62300,
  },
  {
    name: "2025-04-26 08:00",
    tavily: 2464.0,
    openAI: 2009.0,
    claude: 3752.0,
    gemini: 3437.0,
    elevenlabs: 2051.0,
    huggingface: 665.0,
    replicate: 735.0,
    cohere: 542.5,
    stability: 472.5,
    mistral: 385.0,
    cost: 16514.0,
    tokens: 89600000,
    requests: 68600,
  },
  {
    name: "2025-04-26 09:00",
    tavily: 3192.0,
    openAI: 2534.0,
    claude: 4781.0,
    gemini: 4305.0,
    elevenlabs: 2597.0,
    huggingface: 868.0,
    replicate: 962.5,
    cohere: 700.0,
    stability: 612.5,
    mistral: 490.0,
    cost: 21042.5,
    tokens: 115500000,
    requests: 87500,
  },
  {
    name: "2025-04-26 10:00",
    tavily: 3661.0,
    openAI: 2996.0,
    claude: 5313.0,
    gemini: 4788.0,
    elevenlabs: 2884.0,
    huggingface: 966.0,
    replicate: 1050.0,
    cohere: 770.0,
    stability: 647.5,
    mistral: 560.0,
    cost: 23636.0,
    tokens: 129500000,
    requests: 96600,
  },
  {
    name: "2025-04-26 11:00",
    tavily: 3969.0,
    openAI: 3171.0,
    claude: 5684.0,
    gemini: 5096.0,
    elevenlabs: 3045.0,
    huggingface: 1022.0,
    replicate: 1120.0,
    cohere: 805.0,
    stability: 682.5,
    mistral: 595.0,
    cost: 25190.0,
    tokens: 136500000,
    requests: 101500,
  },
  {
    name: "2025-04-26 12:00",
    tavily: 4123.0,
    openAI: 3276.0,
    claude: 5845.0,
    gemini: 5222.0,
    elevenlabs: 3136.0,
    huggingface: 1064.0,
    replicate: 1155.0,
    cohere: 840.0,
    stability: 700.0,
    mistral: 612.5,
    cost: 25974.0,
    tokens: 141400000,
    requests: 104300,
  },
  {
    name: "2025-04-26 13:00",
    tavily: 4004.0,
    openAI: 3192.0,
    claude: 5747.0,
    gemini: 5145.0,
    elevenlabs: 3073.0,
    huggingface: 1036.0,
    replicate: 1120.0,
    cohere: 822.5,
    stability: 682.5,
    mistral: 595.0,
    cost: 25417.0,
    tokens: 138600000,
    requests: 102900,
  },
  {
    name: "2025-04-26 14:00",
    tavily: 3801.0,
    openAI: 3059.0,
    claude: 5488.0,
    gemini: 4886.0,
    elevenlabs: 2912.0,
    huggingface: 987.0,
    replicate: 1067.5,
    cohere: 787.5,
    stability: 665.0,
    mistral: 560.0,
    cost: 24213.5,
    tokens: 132300000,
    requests: 98700,
  },
  {
    name: "2025-04-26 15:00",
    tavily: 3626.0,
    openAI: 2933.0,
    claude: 5222.0,
    gemini: 4641.0,
    elevenlabs: 2779.0,
    huggingface: 945.0,
    replicate: 1015.0,
    cohere: 752.5,
    stability: 630.0,
    mistral: 542.5,
    cost: 23086.0,
    tokens: 127400000,
    requests: 94500,
  },
  {
    name: "2025-04-26 16:00",
    tavily: 3444.0,
    openAI: 2786.0,
    claude: 4935.0,
    gemini: 4403.0,
    elevenlabs: 2625.0,
    huggingface: 896.0,
    replicate: 962.5,
    cohere: 717.5,
    stability: 612.5,
    mistral: 507.5,
    cost: 21889.5,
    tokens: 120400000,
    requests: 90300,
  },
  {
    name: "2025-04-26 17:00",
    tavily: 3269.0,
    openAI: 2653.0,
    claude: 4704.0,
    gemini: 4186.0,
    elevenlabs: 2492.0,
    huggingface: 847.0,
    replicate: 927.5,
    cohere: 682.5,
    stability: 595.0,
    mistral: 490.0,
    cost: 20846.5,
    tokens: 115500000,
    requests: 86100,
  },
  {
    name: "2025-04-26 18:00",
    tavily: 3045.0,
    openAI: 2492.0,
    claude: 4466.0,
    gemini: 3948.0,
    elevenlabs: 2338.0,
    huggingface: 798.0,
    replicate: 875.0,
    cohere: 647.5,
    stability: 560.0,
    mistral: 472.5,
    cost: 19642.0,
    tokens: 108500000,
    requests: 82600,
  },
  {
    name: "2025-04-26 19:00",
    tavily: 2856.0,
    openAI: 2324.0,
    claude: 4207.0,
    gemini: 3703.0,
    elevenlabs: 2191.0,
    huggingface: 749.0,
    replicate: 822.5,
    cohere: 612.5,
    stability: 525.0,
    mistral: 437.5,
    cost: 18428.0,
    tokens: 101500000,
    requests: 78400,
  },
  {
    name: "2025-04-26 20:00",
    tavily: 2681.0,
    openAI: 2205.0,
    claude: 4004.0,
    gemini: 3507.0,
    elevenlabs: 2086.0,
    huggingface: 714.0,
    replicate: 787.5,
    cohere: 577.5,
    stability: 507.5,
    mistral: 402.5,
    cost: 17472.5,
    tokens: 96600000,
    requests: 74900,
  },
  {
    name: "2025-04-26 21:00",
    tavily: 2534.0,
    openAI: 2086.0,
    claude: 3815.0,
    gemini: 3332.0,
    elevenlabs: 1981.0,
    huggingface: 679.0,
    replicate: 752.5,
    cohere: 560.0,
    stability: 490.0,
    mistral: 385.0,
    cost: 16615.0,
    tokens: 92400000,
    requests: 71400,
  },
  {
    name: "2025-04-26 22:00",
    tavily: 2429.0,
    openAI: 1981.0,
    claude: 3647.0,
    gemini: 3206.0,
    elevenlabs: 1904.0,
    huggingface: 651.0,
    replicate: 717.5,
    cohere: 542.5,
    stability: 472.5,
    mistral: 367.5,
    cost: 15918.5,
    tokens: 88200000,
    requests: 68600,
  },
  {
    name: "2025-04-26 23:00",
    tavily: 2303.0,
    openAI: 1869.0,
    claude: 3458.0,
    gemini: 3024.0,
    elevenlabs: 1792.0,
    huggingface: 616.0,
    replicate: 682.5,
    cohere: 507.5,
    stability: 455.0,
    mistral: 350.0,
    cost: 15057.0,
    tokens: 83300000,
    requests: 65100,
  },
];

// Mock trends data - WEEKLY (8 weeks) - scaled up with higher values and additional platforms
export const mockTrendsWeekly = [
  {
    name: "2025-W10",
    tavily: 17171.0,
    openAI: 13902.0,
    claude: 26474.0,
    gemini: 22757.0,
    elevenlabs: 13489.0,
    huggingface: 4256.0,
    replicate: 8750.0,
    cohere: 6125.0,
    stability: 5250.0,
    mistral: 4550.0,
    cost: 122724.0,
    tokens: 784000000,
    requests: 525000,
  },
  {
    name: "2025-W11",
    tavily: 17976.0,
    openAI: 14238.0,
    claude: 27013.0,
    gemini: 23268.0,
    elevenlabs: 13895.0,
    huggingface: 4361.0,
    replicate: 9240.0,
    cohere: 6370.0,
    stability: 5565.0,
    mistral: 4795.0,
    cost: 126721.0,
    tokens: 805000000,
    requests: 539000,
  },
  {
    name: "2025-W12",
    tavily: 18774.0,
    openAI: 14609.0,
    claude: 27272.0,
    gemini: 23646.0,
    elevenlabs: 14203.0,
    huggingface: 4445.0,
    replicate: 9590.0,
    cohere: 6615.0,
    stability: 5705.0,
    mistral: 5005.0,
    cost: 129864.0,
    tokens: 822500000,
    requests: 549500,
  },
  {
    name: "2025-W13",
    tavily: 19313.0,
    openAI: 14721.0,
    claude: 27496.0,
    gemini: 23905.0,
    elevenlabs: 14392.0,
    huggingface: 4494.0,
    replicate: 9870.0,
    cohere: 6755.0,
    stability: 5880.0,
    mistral: 5145.0,
    cost: 131971.0,
    tokens: 833000000,
    requests: 554400,
  },
  {
    name: "2025-W14",
    tavily: 19607.0,
    openAI: 14812.0,
    claude: 27671.0,
    gemini: 24164.0,
    elevenlabs: 14546.0,
    huggingface: 4529.0,
    replicate: 10080.0,
    cohere: 6825.0,
    stability: 5950.0,
    mistral: 5215.0,
    cost: 133399.0,
    tokens: 843500000,
    requests: 558600,
  },
  {
    name: "2025-W15",
    tavily: 19936.0,
    openAI: 14847.0,
    claude: 27804.0,
    gemini: 24381.0,
    elevenlabs: 14658.0,
    huggingface: 4543.0,
    replicate: 10325.0,
    cohere: 6930.0,
    stability: 6020.0,
    mistral: 5320.0,
    cost: 134764.0,
    tokens: 850500000,
    requests: 563500,
  },
  {
    name: "2025-W16",
    tavily: 20268.5,
    openAI: 14868.0,
    claude: 27902.0,
    gemini: 24500.0,
    elevenlabs: 14700.0,
    huggingface: 4550.0,
    replicate: 10500.0,
    cohere: 7035.0,
    stability: 6125.0,
    mistral: 5425.0,
    cost: 135874.0,
    tokens: 840000000,
    requests: 560000,
  },
  {
    name: "2025-W17",
    tavily: 22064.0,
    openAI: 16506.0,
    claude: 29813.0,
    gemini: 26600.0,
    elevenlabs: 16100.0,
    huggingface: 4900.0,
    replicate: 11095.0,
    cohere: 7525.0,
    stability: 6650.0,
    mistral: 5775.0,
    cost: 147028.0,
    tokens: 945000000,
    requests: 630000,
  },
];

// Monthly trends data (12 months) - scaled up
export const mockTrendsMonthly = [
  {
    name: "2024-05",
    tavily: 64435.0,
    openAI: 48321.0,
    claude: 87528.0,
    gemini: 73514.0,
    elevenlabs: 50456.0,
    huggingface: 14721.0,
    replicate: 12500.0,
    cohere: 8750.0,
    stability: 7500.0,
    mistral: 6500.0,
    cost: 374225.0, // Scaled up from 4842.5
    tokens: 2975000000, // Scaled up from 42500000
    requests: 1806000, // Scaled up from 25800
  },
  {
    name: "2024-06",
    tavily: 66556.0,
    openAI: 49392.0,
    claude: 89649.0,
    gemini: 75278.0,
    elevenlabs: 51464.0,
    huggingface: 15092.0,
    replicate: 13200.0,
    cohere: 9100.0,
    stability: 7950.0,
    mistral: 6850.0,
    cost: 384431.0, // Scaled up from 4963.3
    tokens: 3052000000, // Scaled up from 43600000
    requests: 1841000, // Scaled up from 26300
  },
  {
    name: "2024-07",
    tavily: 67914.0,
    openAI: 50456.0,
    claude: 91721.0,
    gemini: 76356.0,
    elevenlabs: 52213.0,
    huggingface: 15428.0,
    replicate: 13720.0,
    cohere: 9450.0,
    stability: 8150.0,
    mistral: 7320.0,
    cost: 392728.0, // Scaled up from 5058.4
    tokens: 3115000000, // Scaled up from 44500000
    requests: 1883000, // Scaled up from 26900
  },
  {
    name: "2024-08",
    tavily: 69475.0,
    openAI: 51464.0,
    claude: 92792.0,
    gemini: 77371.0,
    elevenlabs: 52696.0,
    huggingface: 15729.0,
    replicate: 14150.0,
    cohere: 9850.0,
    stability: 8450.0,
    mistral: 7580.0,
    cost: 399557.0, // Scaled up from 5136.1
    tokens: 3164000000, // Scaled up from 45200000
    requests: 1918000, // Scaled up from 27400
  },
  {
    name: "2024-09",
    tavily: 71106.0,
    openAI: 52528.0,
    claude: 94164.0,
    gemini: 78442.0,
    elevenlabs: 53305.0,
    huggingface: 16023.0,
    replicate: 14650.0,
    cohere: 10200.0,
    stability: 8750.0,
    mistral: 7950.0,
    cost: 407118.0, // Scaled up from 5222.4
    tokens: 3220000000, // Scaled up from 46000000
    requests: 1946000, // Scaled up from 27800
  },
  {
    name: "2024-10",
    tavily: 72492.0,
    openAI: 53606.0,
    claude: 95228.0,
    gemini: 79464.0,
    elevenlabs: 53921.0,
    huggingface: 16275.0,
    replicate: 15150.0,
    cohere: 10550.0,
    stability: 9050.0,
    mistral: 8250.0,
    cost: 413986.0, // Scaled up from 5299.8
    tokens: 3276000000, // Scaled up from 46800000
    requests: 1974000, // Scaled up from 28200
  },
  {
    name: "2024-11",
    tavily: 73871.0,
    openAI: 54642.0,
    claude: 96656.0,
    gemini: 80213.0,
    elevenlabs: 54502.0,
    huggingface: 16527.0,
    replicate: 15750.0,
    cohere: 10900.0,
    stability: 9300.0,
    mistral: 8550.0,
    cost: 420911.0, // Scaled up from 5377.3
    tokens: 3325000000, // Scaled up from 47500000
    requests: 2002000, // Scaled up from 28600
  },
  {
    name: "2024-12",
    tavily: 78799.0,
    openAI: 56714.0,
    claude: 99435.0,
    gemini: 82621.0,
    elevenlabs: 55328.0,
    huggingface: 17164.0,
    replicate: 16350.0,
    cohere: 11250.0,
    stability: 9650.0,
    mistral: 8950.0,
    cost: 436261.0, // Scaled up from 5572.3
    tokens: 3430000000, // Scaled up from 49000000
    requests: 2065000, // Scaled up from 29500
  },
  {
    name: "2025-01",
    tavily: 82271.0,
    openAI: 57781.5,
    claude: 101696.0,
    gemini: 84000.0,
    elevenlabs: 56000.0,
    huggingface: 17500.0,
    replicate: 17100.0,
    cohere: 11650.0,
    stability: 10050.0,
    mistral: 9250.0,
    cost: 447299.0, // Scaled up from 5703.55
    tokens: 3500000000, // Scaled up from 50000000
    requests: 2100000, // Scaled up from 30000
  },
  {
    name: "2025-02",
    tavily: 75964.0,
    openAI: 53571.0,
    claude: 94969.0,
    gemini: 80500.0,
    elevenlabs: 54600.0,
    huggingface: 16800.0,
    replicate: 16500.0,
    cohere: 11200.0,
    stability: 9750.0,
    mistral: 8850.0,
    cost: 422704.0, // Scaled up from 5377.2
    tokens: 3360000000, // Scaled up from 48000000
    requests: 1960000, // Scaled up from 28000
  },
  {
    name: "2025-03",
    tavily: 86131.5,
    openAI: 61085.5,
    claude: 107023.0,
    gemini: 91000.0,
    elevenlabs: 59500.0,
    huggingface: 18200.0,
    replicate: 17850.0,
    cohere: 12250.0,
    stability: 10550.0,
    mistral: 9850.0,
    cost: 473440.0, // Scaled up from 6042.0
    tokens: 3850000000, // Scaled up from 55000000
    requests: 2240000, // Scaled up from 32000
  },
  {
    name: "2025-04",
    tavily: 37956.75,
    openAI: 27237.0,
    claude: 97237.0,
    gemini: 52696.0,
    elevenlabs: 29505.0,
    huggingface: 10850.0,
    replicate: 15420.0,
    cohere: 12840.0,
    stability: 9780.0,
    mistral: 8730.0,
    cost: 302251.75, // Matches the current month's summary
    tokens: 2100000000, // Matches the current month's summary
    requests: 1400000, // Matches the current month's summary
  },
];

// Mock trends data - YEARLY (2 years with monthly breakdown) - scaled up with higher values and additional platforms
export const mockTrendsYearly = [
  {
    name: "2024-01",
    tavily: 59521.0,
    openAI: 45514.0,
    claude: 80542.0,
    gemini: 0.0,
    elevenlabs: 0.0,
    huggingface: 0.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 185577.0,
    tokens: 2450000000,
    requests: 1540000,
  },
  {
    name: "2024-02",
    tavily: 61285.0,
    openAI: 46956.0,
    claude: 82621.0,
    gemini: 0.0,
    elevenlabs: 0.0,
    huggingface: 0.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 190862.0,
    tokens: 2520000000,
    requests: 1596000,
  },
  {
    name: "2024-03",
    tavily: 62664.0,
    openAI: 47978.0,
    claude: 84749.0,
    gemini: 63035.0,
    elevenlabs: 0.0,
    huggingface: 0.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 258426.0,
    tokens: 2695000000,
    requests: 1666000,
  },
  {
    name: "2024-04",
    tavily: 63756.0,
    openAI: 48692.0,
    claude: 86464.0,
    gemini: 71771.0,
    elevenlabs: 47614.0,
    huggingface: 0.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 318297.0,
    tokens: 2870000000,
    requests: 1750000,
  },
  {
    name: "2024-05",
    tavily: 64435.0,
    openAI: 48321.0,
    claude: 87528.0,
    gemini: 73514.0,
    elevenlabs: 50456.0,
    huggingface: 0.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 324254.0,
    tokens: 2975000000,
    requests: 1806000,
  },
  {
    name: "2024-06",
    tavily: 66556.0,
    openAI: 49392.0,
    claude: 89649.0,
    gemini: 75278.0,
    elevenlabs: 51464.0,
    huggingface: 0.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 332339.0,
    tokens: 3052000000,
    requests: 1841000,
  },
  {
    name: "2024-07",
    tavily: 67914.0,
    openAI: 50456.0,
    claude: 91721.0,
    gemini: 76356.0,
    elevenlabs: 52213.0,
    huggingface: 14385.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 353045.0,
    tokens: 3115000000,
    requests: 1883000,
  },
  {
    name: "2024-08",
    tavily: 69475.0,
    openAI: 51464.0,
    claude: 92792.0,
    gemini: 77371.0,
    elevenlabs: 52696.0,
    huggingface: 15729.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 359527.0,
    tokens: 3164000000,
    requests: 1918000,
  },
  {
    name: "2024-09",
    tavily: 71106.0,
    openAI: 52528.0,
    claude: 94164.0,
    gemini: 78442.0,
    elevenlabs: 53305.0,
    huggingface: 16023.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 365568.0,
    tokens: 3220000000,
    requests: 1946000,
  },
  {
    name: "2024-10",
    tavily: 72492.0,
    openAI: 53606.0,
    claude: 95228.0,
    gemini: 79464.0,
    elevenlabs: 53921.0,
    huggingface: 16275.0,
    replicate: 0.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 370986.0,
    tokens: 3276000000,
    requests: 1974000,
  },
  {
    name: "2024-11",
    tavily: 73871.0,
    openAI: 54642.0,
    claude: 96656.0,
    gemini: 80213.0,
    elevenlabs: 54502.0,
    huggingface: 16527.0,
    replicate: 13300.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 389711.0,
    tokens: 3325000000,
    requests: 2002000,
  },
  {
    name: "2024-12",
    tavily: 78799.0,
    openAI: 56714.0,
    claude: 99435.0,
    gemini: 82621.0,
    elevenlabs: 55328.0,
    huggingface: 17164.0,
    replicate: 14175.0,
    cohere: 0.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 404236.0,
    tokens: 3430000000,
    requests: 2065000,
  },
  {
    name: "2025-01",
    tavily: 82271.0,
    openAI: 57781.5,
    claude: 101696.0,
    gemini: 84000.0,
    elevenlabs: 56000.0,
    huggingface: 17500.0,
    replicate: 15225.0,
    cohere: 10500.0,
    stability: 0.0,
    mistral: 0.0,
    cost: 424973.5,
    tokens: 3500000000,
    requests: 2100000,
  },
  {
    name: "2025-02",
    tavily: 75964.0,
    openAI: 53571.0,
    claude: 94969.0,
    gemini: 80500.0,
    elevenlabs: 54600.0,
    huggingface: 16800.0,
    replicate: 15750.0,
    cohere: 11200.0,
    stability: 9750.0,
    mistral: 0.0,
    cost: 413104.0,
    tokens: 3360000000,
    requests: 1960000,
  },
  {
    name: "2025-03",
    tavily: 86131.5,
    openAI: 61085.5,
    claude: 107023.0,
    gemini: 91000.0,
    elevenlabs: 59500.0,
    huggingface: 18200.0,
    replicate: 16800.0,
    cohere: 11900.0,
    stability: 10150.0,
    mistral: 8400.0,
    cost: 470190.0,
    tokens: 3850000000,
    requests: 2240000,
  },
  {
    name: "2025-04",
    tavily: 37956.75,
    openAI: 27237.0,
    claude: 97237.0,
    gemini: 52696.0,
    elevenlabs: 29505.0,
    huggingface: 10850.0,
    replicate: 15420.0,
    cohere: 12840.0,
    stability: 9780.0,
    mistral: 8730.0,
    cost: 302251.75,
    tokens: 2100000000,
    requests: 1400000,
  },
];

// Mock detailed usage data by platform (updated with new platforms and higher costs)
export const mockDetailedUsageByPlatform = [
  {
    _id: mockPlatformId1,
    platform_name: "tavily",
    totalCost: 37956.75,
    items: [
      {
        unit_type: "credit",
        unit_name: "basic_search_credit",
        model_name: undefined,
        feature_name: "basic_search",
        quantity: 3500000,
        cost: 26250.0, // Scaled up from 375.0
        attributes: { search_depth: "basic" },
      },
      {
        unit_type: "credit",
        unit_name: "advanced_search_credit",
        model_name: undefined,
        feature_name: "advanced_search",
        quantity: 1050000,
        cost: 8400.0, // Scaled up from 120.0
        attributes: { search_depth: "advanced" },
      },
      {
        unit_type: "credit",
        unit_name: "basic_extract_credit",
        model_name: undefined,
        feature_name: "basic_extract",
        quantity: 700000,
        cost: 2625.0, // Scaled up from 75.0
        attributes: { extract_depth: "basic" },
      },
      {
        unit_type: "credit",
        unit_name: "document_processing_credit",
        model_name: undefined,
        feature_name: "document_processing",
        quantity: 68175,
        cost: 681.75, // New item
        attributes: { processing_type: "pdf" },
      },
    ],
  },
  {
    _id: mockPlatformId2,
    platform_name: "openAI",
    totalCost: 27237.0,
    items: [
      {
        unit_type: "token",
        unit_name: "gpt-3.5-turbo input_token",
        model_name: "gpt-3.5-turbo",
        feature_name: undefined,
        quantity: 350000000,
        cost: 175.0, // Scaled up from 2.5
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "gpt-3.5-turbo output_token",
        model_name: "gpt-3.5-turbo",
        feature_name: undefined,
        quantity: 210000000,
        cost: 315.0, // Scaled up from 4.5
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "gpt-4o input_token",
        model_name: "gpt-4o",
        feature_name: undefined,
        quantity: 140000000,
        cost: 1400.0, // Scaled up from 20.0
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "gpt-4o output_token",
        model_name: "gpt-4o",
        feature_name: undefined,
        quantity: 70000000,
        cost: 2100.0, // Scaled up from 30.0
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "gpt-4-turbo input_token",
        model_name: "gpt-4-turbo",
        feature_name: undefined,
        quantity: 120000000,
        cost: 3600.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "gpt-4-turbo output_token",
        model_name: "gpt-4-turbo",
        feature_name: undefined,
        quantity: 70000000,
        cost: 4200.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "character",
        unit_name: "tts_character",
        model_name: undefined,
        feature_name: "tts",
        quantity: 7000000,
        cost: 105.0, // Scaled up from 1.5
        attributes: {},
      },
      {
        unit_type: "minute",
        unit_name: "whisper_minute",
        model_name: "whisper",
        feature_name: "whisper",
        quantity: 3520,
        cost: 352.0, // New item
        attributes: {},
      },
      {
        unit_type: "image",
        unit_name: "dall-e-3_image",
        model_name: "dall-e-3",
        feature_name: "image_generation",
        quantity: 374750,
        cost: 14990.0, // New item
        attributes: { resolution: "1024x1024" },
      },
    ],
  },
  {
    _id: mockPlatformId3,
    platform_name: "claude",
    totalCost: 97237.0,
    items: [
      {
        unit_type: "token",
        unit_name: "claude-3-sonnet input_token",
        model_name: "claude-3-sonnet",
        feature_name: undefined,
        quantity: 210000000,
        cost: 630.0, // Scaled up from 9.0
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3-sonnet output_token",
        model_name: "claude-3-sonnet",
        feature_name: undefined,
        quantity: 420000000,
        cost: 6300.0, // Scaled up from 90.0
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3-opus input_token",
        model_name: "claude-3-opus",
        feature_name: undefined,
        quantity: 70000000,
        cost: 1050.0, // Scaled up from 15.0
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3-opus output_token",
        model_name: "claude-3-opus",
        feature_name: undefined,
        quantity: 140000000,
        cost: 10500.0, // Scaled up from 150.0
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3-haiku input_token",
        model_name: "claude-3-haiku",
        feature_name: undefined,
        quantity: 500000000,
        cost: 625.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3-haiku output_token",
        model_name: "claude-3-haiku",
        feature_name: undefined,
        quantity: 350000000,
        cost: 1312.5, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3.7-sonnet input_token",
        model_name: "claude-3.7-sonnet",
        feature_name: undefined,
        quantity: 200000000,
        cost: 1200.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3.7-sonnet output_token",
        model_name: "claude-3.7-sonnet",
        feature_name: undefined,
        quantity: 180000000,
        cost: 5400.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "claude-2 input_token",
        model_name: "claude-2",
        feature_name: undefined,
        quantity: 350000000,
        cost: 280.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "claude-2 output_token",
        model_name: "claude-2",
        feature_name: undefined,
        quantity: 320000000,
        cost: 768.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "prompt_caching_write",
        model_name: undefined,
        feature_name: "prompt_caching_write",
        quantity: 35000000,
        cost: 131.6, // Scaled up from 1.88
        attributes: {},
      },
      {
        unit_type: "token",
        unit_name: "prompt_caching_read",
        model_name: undefined,
        feature_name: "prompt_caching_read",
        quantity: 70000000,
        cost: 21.0, // Scaled up from 0.3
        attributes: {},
      },
      {
        unit_type: "token",
        unit_name: "bedrock_integration",
        model_name: undefined,
        feature_name: "bedrock_integration",
        quantity: 280000000,
        cost: 69018.9, // New item
        attributes: { integration_type: "aws" },
      },
    ],
  },
  {
    _id: mockPlatformId4,
    platform_name: "gemini",
    totalCost: 52696.0,
    items: [
      {
        unit_type: "token",
        unit_name: "gemini-1.5-flash input_token",
        model_name: "gemini-1.5-flash",
        feature_name: undefined,
        quantity: 280000000,
        cost: 210.0, // Scaled up from 3.0
        attributes: { token_type: "input", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-flash output_token",
        model_name: "gemini-1.5-flash",
        feature_name: undefined,
        quantity: 140000000,
        cost: 42.0, // Scaled up from 0.6
        attributes: { token_type: "output", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-pro input_token",
        model_name: "gemini-1.5-pro",
        feature_name: undefined,
        quantity: 70000000,
        cost: 87.5, // Scaled up from 1.25
        attributes: { token_type: "input", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-pro output_token",
        model_name: "gemini-1.5-pro",
        feature_name: undefined,
        quantity: 35000000,
        cost: 175.0, // Scaled up from 2.5
        attributes: { token_type: "output", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-ultra input_token",
        model_name: "gemini-1.5-ultra",
        feature_name: undefined,
        quantity: 200000000,
        cost: 2000.0, // New item
        attributes: { token_type: "input", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-ultra output_token",
        model_name: "gemini-1.5-ultra",
        feature_name: undefined,
        quantity: 150000000,
        cost: 4500.0, // New item
        attributes: { token_type: "output", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-flash input_token",
        model_name: "gemini-1.5-flash",
        feature_name: undefined,
        quantity: 120000000,
        cost: 150.0, // New item (for large context)
        attributes: { token_type: "input", prompt_size: ">128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-flash output_token",
        model_name: "gemini-1.5-flash",
        feature_name: undefined,
        quantity: 85000000,
        cost: 42.5, // New item (for large context)
        attributes: { token_type: "output", prompt_size: ">128k" },
      },
      {
        unit_type: "request",
        unit_name: "google_search_grounding_request",
        model_name: undefined,
        feature_name: "Google Search_grounding",
        quantity: 3500,
        cost: 122.5, // Scaled up from 1.75
        attributes: {},
      },
      {
        unit_type: "token_hour",
        unit_name: "context_caching_storage_token_hour",
        model_name: undefined,
        feature_name: "context_caching_storage",
        quantity: 7000000,
        cost: 7.0, // Scaled up from 0.1
        attributes: {},
      },
      {
        unit_type: "image",
        unit_name: "imagen_generation",
        model_name: "imagen",
        feature_name: "image_generation",
        quantity: 250000,
        cost: 45000.0, // New item
        attributes: { resolution: "1024x1024" },
      },
      {
        unit_type: "video",
        unit_name: "video_generation",
        model_name: "veo",
        feature_name: "video_generation",
        quantity: 1800,
        cost: 359.0, // New item
        attributes: { resolution: "1080p", duration: "15s" },
      },
    ],
  },
  {
    _id: mockPlatformId5,
    platform_name: "elevenlabs",
    totalCost: 29505.0,
    items: [
      {
        unit_type: "credit",
        unit_name: "text_to_speech_multilingual_credit",
        model_name: undefined,
        feature_name: "text_to_speech_multilingual",
        quantity: 35000000,
        cost: 3150.0, // Scaled up from 45.0
        attributes: { quality: "high" },
      },
      {
        unit_type: "credit",
        unit_name: "text_to_speech_flash_credit",
        model_name: undefined,
        feature_name: "text_to_speech_flash",
        quantity: 14000000,
        cost: 1260.0, // Scaled up from 18.0
        attributes: { quality: "low_latency" },
      },
      {
        unit_type: "credit",
        unit_name: "conversational_ai_credit",
        model_name: undefined,
        feature_name: "conversational_ai",
        quantity: 7000000,
        cost: 630.0, // Scaled up from 9.0
        attributes: {},
      },
      {
        unit_type: "credit",
        unit_name: "voice_design_credit",
        model_name: undefined,
        feature_name: "voice_design",
        quantity: 5000000,
        cost: 1000.0, // New item
        attributes: { voice_type: "custom" },
      },
      {
        unit_type: "credit",
        unit_name: "voice_cloning_credit",
        model_name: undefined,
        feature_name: "voice_cloning",
        quantity: 5750,
        cost: 17250.0, // New item
        attributes: { cloning_type: "professional" },
      },
      {
        unit_type: "character",
        unit_name: "speech_to_speech_character",
        model_name: undefined,
        feature_name: "speech_to_speech",
        quantity: 18750000,
        cost: 5625.0, // New item
        attributes: { conversion_type: "accent" },
      },
      {
        unit_type: "minute",
        unit_name: "dubbing_minute",
        model_name: undefined,
        feature_name: "dubbing",
        quantity: 590,
        cost: 590.0, // New item
        attributes: { language_pair: "en-es" },
      },
    ],
  },
  {
    _id: mockPlatformId6,
    platform_name: "huggingface",
    totalCost: 10850.0,
    items: [
      {
        unit_type: "compute",
        unit_name: "inference_api_compute_gpu",
        model_name: "some-text-generation-model",
        feature_name: "inference_api",
        quantity: 252000,
        cost: 30.1, // Scaled up from 0.43
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "inference_api_compute_cpu",
        model_name: "some-embedding-model",
        feature_name: "inference_api",
        quantity: 504000,
        cost: 25.2, // Scaled up from 0.36
        attributes: { hardware: "cpu" },
      },
      {
        unit_type: "compute",
        unit_name: "inference_api_compute_gpu",
        model_name: "llama-70b",
        feature_name: "inference_api",
        quantity: 750000,
        cost: 375.0, // New item
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "fine_tuning_compute",
        model_name: undefined,
        feature_name: "fine_tuning",
        quantity: 185000,
        cost: 9250.0, // New item
        attributes: { hardware: "gpu", instance_type: "A100" },
      },
      {
        unit_type: "storage",
        unit_name: "model_storage_gb",
        model_name: undefined,
        feature_name: "model_storage",
        quantity: 8500,
        cost: 850.0, // New item
        attributes: { storage_type: "standard" },
      },
      {
        unit_type: "request",
        unit_name: "inference_widget_request",
        model_name: undefined,
        feature_name: "inference_widget",
        quantity: 35000,
        cost: 0.0, // Scaled up from 0.0
        attributes: {},
      },
      {
        unit_type: "compute",
        unit_name: "spaces_compute",
        model_name: undefined,
        feature_name: "spaces",
        quantity: 4000,
        cost: 319.7, // New item
        attributes: { hardware: "gpu", instance_type: "T4" },
      },
    ],
  },
  {
    _id: mockPlatformId7,
    platform_name: "replicate",
    totalCost: 15420.0,
    items: [
      {
        unit_type: "compute",
        unit_name: "prediction_compute",
        model_name: "stability-ai/sdxl",
        feature_name: "prediction",
        quantity: 250000,
        cost: 5000.0, // New item
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "prediction_compute",
        model_name: "meta/llama-3-70b-instruct",
        feature_name: "prediction",
        quantity: 175000,
        cost: 3500.0, // New item
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "training_compute",
        model_name: "custom-fine-tuning",
        feature_name: "training",
        quantity: 93000,
        cost: 4650.0, // New item
        attributes: { hardware: "gpu", instance_type: "A100" },
      },
      {
        unit_type: "compute",
        unit_name: "prediction_compute",
        model_name: "anthropic/claude-3-sonnet",
        feature_name: "prediction",
        quantity: 85000,
        cost: 1700.0, // New item
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "storage",
        unit_name: "model_storage_gb",
        model_name: undefined,
        feature_name: "model_storage",
        quantity: 5700,
        cost: 570.0, // New item
        attributes: { storage_type: "standard" },
      },
    ],
  },
  {
    _id: mockPlatformId8,
    platform_name: "cohere",
    totalCost: 12840.0,
    items: [
      {
        unit_type: "token",
        unit_name: "command-r input_token",
        model_name: "command-r",
        feature_name: undefined,
        quantity: 150000000,
        cost: 750.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "command-r output_token",
        model_name: "command-r",
        feature_name: undefined,
        quantity: 120000000,
        cost: 1200.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "command-r-plus input_token",
        model_name: "command-r-plus",
        feature_name: undefined,
        quantity: 200000000,
        cost: 2000.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "command-r-plus output_token",
        model_name: "command-r-plus",
        feature_name: undefined,
        quantity: 180000000,
        cost: 3600.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "embed-english",
        model_name: "embed-english",
        feature_name: "embedding",
        quantity: 850000000,
        cost: 1275.0, // New item
        attributes: {},
      },
      {
        unit_type: "token",
        unit_name: "embed-multilingual",
        model_name: "embed-multilingual",
        feature_name: "embedding",
        quantity: 650000000,
        cost: 1625.0, // New item
        attributes: {},
      },
      {
        unit_type: "dataset",
        unit_name: "rag_dataset",
        model_name: undefined,
        feature_name: "rag",
        quantity: 23.9,
        cost: 2390.0, // New item
        attributes: { size_gb: "23.9" },
      },
    ],
  },
  {
    _id: mockPlatformId9,
    platform_name: "stability",
    totalCost: 9780.0,
    items: [
      {
        unit_type: "credit",
        unit_name: "standard_credit",
        model_name: "stable-diffusion-xl",
        feature_name: "image_generation",
        quantity: 127500,
        cost: 3825.0, // New item
        attributes: { resolution: "1024x1024" },
      },
      {
        unit_type: "credit",
        unit_name: "upscale_credit",
        model_name: "esrgan",
        feature_name: "image_upscaling",
        quantity: 25600,
        cost: 768.0, // New item
        attributes: {},
      },
      {
        unit_type: "credit",
        unit_name: "standard_credit",
        model_name: "stable-video-diffusion",
        feature_name: "video_generation",
        quantity: 57800,
        cost: 4046.0, // New item
        attributes: { seconds: "5" },
      },
      {
        unit_type: "credit",
        unit_name: "inpainting_credit",
        model_name: "stable-diffusion-xl-inpainting",
        feature_name: "image_editing",
        quantity: 38031,
        cost: 1141.0, // New item
        attributes: {},
      },
    ],
  },
  {
    _id: mockPlatformId10,
    platform_name: "mistral",
    totalCost: 8730.0,
    items: [
      {
        unit_type: "token",
        unit_name: "mistral-small-latest input_token",
        model_name: "mistral-small-latest",
        feature_name: undefined,
        quantity: 295000000,
        cost: 590.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "mistral-small-latest output_token",
        model_name: "mistral-small-latest",
        feature_name: undefined,
        quantity: 250000000,
        cost: 1000.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "mistral-large-latest input_token",
        model_name: "mistral-large-latest",
        feature_name: undefined,
        quantity: 78500000,
        cost: 1570.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "mistral-large-latest output_token",
        model_name: "mistral-large-latest",
        feature_name: undefined,
        quantity: 68000000,
        cost: 2720.0, // New item
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "embedding",
        model_name: "mistral-embed",
        feature_name: "embedding",
        quantity: 850000000,
        cost: 850.0, // New item
        attributes: {},
      },
      {
        unit_type: "token",
        unit_name: "mixtral-8x7b input_token",
        model_name: "mixtral-8x7b",
        feature_name: undefined,
        quantity: 150000000,
        cost: 750.0, // New item
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "mixtral-8x7b output_token",
        model_name: "mixtral-8x7b",
        feature_name: undefined,
        quantity: 125000000,
        cost: 1250.0, // New item
        attributes: { token_type: "output" },
      },
    ],
  },
];

// Example for export data aligned with DashboardController.exportData response
// This represents a sample of export data with expanded fields and item types
export const mockExportDataContent = [
  // tavily items (first few examples)
  {
    date: "2025-04-22",
    platform_id: mockPlatformId1,
    platform_name: "tavily",
    user_id: mockUserId,
    unit_type: "credit",
    quantity: 3500000,
    rate_per_unit: 0.0075,
    item_cost: 26250.0,
    model_name: null,
    feature_name: "basic_search",
    attributes: { search_depth: "basic" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId1,
    platform_name: "tavily",
    user_id: mockUserId,
    unit_type: "credit",
    quantity: 1050000,
    rate_per_unit: 0.008,
    item_cost: 8400.0,
    model_name: null,
    feature_name: "advanced_search",
    attributes: { search_depth: "advanced" },
  },

  // openAI items (first few examples)
  {
    date: "2025-04-22",
    platform_id: mockPlatformId2,
    platform_name: "openAI",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 350000000,
    rate_per_unit: 0.0000005,
    item_cost: 175.0,
    model_name: "gpt-3.5-turbo",
    feature_name: null,
    attributes: { token_type: "input" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId2,
    platform_name: "openAI",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 210000000,
    rate_per_unit: 0.0000015,
    item_cost: 315.0,
    model_name: "gpt-3.5-turbo",
    feature_name: null,
    attributes: { token_type: "output" },
  },

  // claude items (first few examples)
  {
    date: "2025-04-22",
    platform_id: mockPlatformId3,
    platform_name: "claude",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 210000000,
    rate_per_unit: 0.000003,
    item_cost: 630.0,
    model_name: "claude-3-sonnet",
    feature_name: null,
    attributes: { token_type: "input" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId3,
    platform_name: "claude",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 420000000,
    rate_per_unit: 0.000015,
    item_cost: 6300.0,
    model_name: "claude-3-sonnet",
    feature_name: null,
    attributes: { token_type: "output" },
  },

  // gemini items (first few examples)
  {
    date: "2025-04-22",
    platform_id: mockPlatformId4,
    platform_name: "gemini",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 280000000,
    rate_per_unit: 0.00000075,
    item_cost: 210.0,
    model_name: "gemini-1.5-flash",
    feature_name: null,
    attributes: { token_type: "input", prompt_size: "<=128k" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId4,
    platform_name: "gemini",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 140000000,
    rate_per_unit: 0.0000003,
    item_cost: 42.0,
    model_name: "gemini-1.5-flash",
    feature_name: null,
    attributes: { token_type: "output", prompt_size: "<=128k" },
  },

  // New platforms examples
  {
    date: "2025-04-22",
    platform_id: mockPlatformId7,
    platform_name: "replicate",
    user_id: mockUserId,
    unit_type: "compute",
    quantity: 250000,
    rate_per_unit: 0.02,
    item_cost: 5000.0,
    model_name: "stability-ai/sdxl",
    feature_name: "prediction",
    attributes: { hardware: "gpu" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId8,
    platform_name: "cohere",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 150000000,
    rate_per_unit: 0.000005,
    item_cost: 750.0,
    model_name: "command-r",
    feature_name: null,
    attributes: { token_type: "input" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId9,
    platform_name: "stability",
    user_id: mockUserId,
    unit_type: "credit",
    quantity: 127500,
    rate_per_unit: 0.03,
    item_cost: 3825.0,
    model_name: "stable-diffusion-xl",
    feature_name: "image_generation",
    attributes: { resolution: "1024x1024" },
  },
  {
    date: "2025-04-22",
    platform_id: mockPlatformId10,
    platform_name: "mistral",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 295000000,
    rate_per_unit: 0.000002,
    item_cost: 590.0,
    model_name: "mistral-small-latest",
    feature_name: null,
    attributes: { token_type: "input" },
  },

  // Example rows for different date periods
  {
    date: "2025-04-21",
    platform_id: mockPlatformId3,
    platform_name: "claude",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 180000000,
    rate_per_unit: 0.000003,
    item_cost: 540.0,
    model_name: "claude-3-sonnet",
    feature_name: null,
    attributes: { token_type: "input" },
  },
  {
    date: "2025-04-20",
    platform_id: mockPlatformId4,
    platform_name: "gemini",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 250000000,
    rate_per_unit: 0.00000075,
    item_cost: 187.5,
    model_name: "gemini-1.5-flash",
    feature_name: null,
    attributes: { token_type: "input", prompt_size: "<=128k" },
  },
  {
    date: "2025-04-19",
    platform_id: mockPlatformId2,
    platform_name: "openAI",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 320000000,
    rate_per_unit: 0.0000005,
    item_cost: 160.0,
    model_name: "gpt-3.5-turbo",
    feature_name: null,
    attributes: { token_type: "input" },
  },
  {
    date: "2025-04-18",
    platform_id: mockPlatformId5,
    platform_name: "elevenlabs",
    user_id: mockUserId,
    unit_type: "credit",
    quantity: 30000000,
    rate_per_unit: 0.00009,
    item_cost: 2700.0,
    model_name: null,
    feature_name: "text_to_speech_multilingual",
    attributes: { quality: "high" },
  },
  {
    date: "2025-04-17",
    platform_id: mockPlatformId8,
    platform_name: "cohere",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 140000000,
    rate_per_unit: 0.000005,
    item_cost: 700.0,
    model_name: "command-r",
    feature_name: null,
    attributes: { token_type: "input" },
  },
  {
    date: "2025-04-16",
    platform_id: mockPlatformId7,
    platform_name: "replicate",
    user_id: mockUserId,
    unit_type: "compute",
    quantity: 220000,
    rate_per_unit: 0.02,
    item_cost: 4400.0,
    model_name: "stability-ai/sdxl",
    feature_name: "prediction",
    attributes: { hardware: "gpu" },
  },
  {
    date: "2025-04-15",
    platform_id: mockPlatformId10,
    platform_name: "mistral",
    user_id: mockUserId,
    unit_type: "token",
    quantity: 270000000,
    rate_per_unit: 0.000002,
    item_cost: 540.0,
    model_name: "mistral-small-latest",
    feature_name: null,
    attributes: { token_type: "input" },
  },
];

// Platform name map with additional platforms
export const mockPlatformNameMap = {
  [mockPlatformId1]: "tavily",
  [mockPlatformId2]: "openAI",
  [mockPlatformId3]: "claude",
  [mockPlatformId4]: "gemini",
  [mockPlatformId5]: "elevenlabs",
  [mockPlatformId6]: "huggingface",
  [mockPlatformId7]: "replicate",
  [mockPlatformId8]: "cohere",
  [mockPlatformId9]: "stability",
  [mockPlatformId10]: "mistral",
};

// Updated mock comparison data with new platforms
export const mockComparisonData = {
  metric: "cost", // The metric currently being compared
  data: [
    {
      name: "claude",
      value: 97237.0,
      totalCost: 97237.0,
      totalTokens: 2730000000,
      totalRequests: 85400,
    },
    {
      name: "gemini",
      value: 52696.0,
      totalCost: 52696.0,
      totalTokens: 810000000,
      totalRequests: 3500,
    },
    {
      name: "tavily",
      value: 37956.75,
      totalCost: 37956.75,
      totalTokens: 0,
      totalRequests: 70000,
    },
    {
      name: "elevenlabs",
      value: 29505.0,
      totalCost: 29505.0,
      totalTokens: 0,
      totalRequests: 0,
      totalCharacters: 105000000,
      totalMinutes: 175000,
      totalCredits: 56000000,
    },
    {
      name: "openAI",
      value: 27237.0,
      totalCost: 27237.0,
      totalTokens: 960000000,
      totalRequests: 378350,
      totalImages: 374750,
      totalMinutes: 3520,
    },
    {
      name: "replicate",
      value: 15420.0,
      totalCost: 15420.0,
      totalTokens: 0,
      totalRequests: 0,
      totalCompute: 603000,
      storageGB: 5700,
    },
    {
      name: "cohere",
      value: 12840.0,
      totalCost: 12840.0,
      totalTokens: 2150000000,
      totalRequests: 0,
      datasetSizeGB: 23.9,
    },
    {
      name: "huggingface",
      value: 10850.0,
      totalCost: 10850.0,
      totalTokens: 0,
      totalRequests: 35000,
      totalCompute: 1191000,
      storageGB: 8500,
    },
    {
      name: "stability",
      value: 9780.0,
      totalCost: 9780.0,
      totalTokens: 0,
      totalRequests: 0,
      totalCredits: 248931,
    },
    {
      name: "mistral",
      value: 8730.0,
      totalCost: 8730.0,
      totalTokens: 1968500000,
      totalRequests: 0,
    },
  ],
  startDate: "2025-03-28T00:00:00.000Z",
  endDate: "2025-04-27T00:00:00.000Z",
};

// Example for groupBy: 'item' with expanded items
export const mockDetailedUsageByItem = [
  {
    unit_type: "token",
    unit_name: "claude-3-sonnet input_token",
    model_name: "claude-3-sonnet",
    feature_name: undefined,
    totalQuantity: 210000000,
    totalCost: 630.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3-sonnet output_token",
    model_name: "claude-3-sonnet",
    feature_name: undefined,
    totalQuantity: 420000000,
    totalCost: 6300.0,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3-opus input_token",
    model_name: "claude-3-opus",
    feature_name: undefined,
    totalQuantity: 70000000,
    totalCost: 1050.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3-opus output_token",
    model_name: "claude-3-opus",
    feature_name: undefined,
    totalQuantity: 140000000,
    totalCost: 10500.0,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3-haiku input_token",
    model_name: "claude-3-haiku",
    feature_name: undefined,
    totalQuantity: 500000000,
    totalCost: 625.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3-haiku output_token",
    model_name: "claude-3-haiku",
    feature_name: undefined,
    totalQuantity: 350000000,
    totalCost: 1312.5,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3.7-sonnet input_token",
    model_name: "claude-3.7-sonnet",
    feature_name: undefined,
    totalQuantity: 200000000,
    totalCost: 1200.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "claude-3.7-sonnet output_token",
    model_name: "claude-3.7-sonnet",
    feature_name: undefined,
    totalQuantity: 180000000,
    totalCost: 5400.0,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "gpt-3.5-turbo input_token",
    model_name: "gpt-3.5-turbo",
    feature_name: undefined,
    totalQuantity: 350000000,
    totalCost: 175.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "gpt-3.5-turbo output_token",
    model_name: "gpt-3.5-turbo",
    feature_name: undefined,
    totalQuantity: 210000000,
    totalCost: 315.0,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "gpt-4o input_token",
    model_name: "gpt-4o",
    feature_name: undefined,
    totalQuantity: 140000000,
    totalCost: 1400.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "gpt-4o output_token",
    model_name: "gpt-4o",
    feature_name: undefined,
    totalQuantity: 70000000,
    totalCost: 2100.0,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "gemini-1.5-ultra input_token",
    model_name: "gemini-1.5-ultra",
    feature_name: undefined,
    totalQuantity: 200000000,
    totalCost: 2000.0,
    attributes: { token_type: "input", prompt_size: "<=128k" },
  },
  {
    unit_type: "token",
    unit_name: "gemini-1.5-ultra output_token",
    model_name: "gemini-1.5-ultra",
    feature_name: undefined,
    totalQuantity: 150000000,
    totalCost: 4500.0,
    attributes: { token_type: "output", prompt_size: "<=128k" },
  },
  {
    unit_type: "credit",
    unit_name: "basic_search_credit",
    model_name: undefined,
    feature_name: "basic_search",
    totalQuantity: 3500000,
    totalCost: 26250.0,
    attributes: { search_depth: "basic" },
  },
  {
    unit_type: "credit",
    unit_name: "advanced_search_credit",
    model_name: undefined,
    feature_name: "advanced_search",
    totalQuantity: 1050000,
    totalCost: 8400.0,
    attributes: { search_depth: "advanced" },
  },
  {
    unit_type: "compute",
    unit_name: "inference_api_compute_gpu",
    model_name: "some-text-generation-model",
    feature_name: "inference_api",
    totalQuantity: 252000,
    totalCost: 30.1,
    attributes: { hardware: "gpu" },
  },
  {
    unit_type: "compute",
    unit_name: "fine_tuning_compute",
    model_name: undefined,
    feature_name: "fine_tuning",
    totalQuantity: 185000,
    totalCost: 9250.0,
    attributes: { hardware: "gpu", instance_type: "A100" },
  },
  {
    unit_type: "compute",
    unit_name: "prediction_compute",
    model_name: "stability-ai/sdxl",
    feature_name: "prediction",
    totalQuantity: 250000,
    totalCost: 5000.0,
    attributes: { hardware: "gpu" },
  },
  {
    unit_type: "token",
    unit_name: "command-r-plus input_token",
    model_name: "command-r-plus",
    feature_name: undefined,
    totalQuantity: 200000000,
    totalCost: 2000.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "credit",
    unit_name: "standard_credit",
    model_name: "stable-diffusion-xl",
    feature_name: "image_generation",
    totalQuantity: 127500,
    totalCost: 3825.0,
    attributes: { resolution: "1024x1024" },
  },
  {
    unit_type: "token",
    unit_name: "mistral-large-latest input_token",
    model_name: "mistral-large-latest",
    feature_name: undefined,
    totalQuantity: 78500000,
    totalCost: 1570.0,
    attributes: { token_type: "input" },
  },
  {
    unit_type: "token",
    unit_name: "mistral-large-latest output_token",
    model_name: "mistral-large-latest",
    feature_name: undefined,
    totalQuantity: 68000000,
    totalCost: 2720.0,
    attributes: { token_type: "output" },
  },
  {
    unit_type: "token",
    unit_name: "bedrock_integration",
    model_name: undefined,
    feature_name: "bedrock_integration",
    totalQuantity: 280000000,
    totalCost: 69018.9,
    attributes: { integration_type: "aws" },
  },
  {
    unit_type: "image",
    unit_name: "dall-e-3_image",
    model_name: "dall-e-3",
    feature_name: "image_generation",
    totalQuantity: 374750,
    totalCost: 14990.0,
    attributes: { resolution: "1024x1024" },
  },
  {
    unit_type: "credit",
    unit_name: "voice_cloning_credit",
    model_name: undefined,
    feature_name: "voice_cloning",
    totalQuantity: 5750,
    totalCost: 17250.0,
    attributes: { cloning_type: "professional" },
  },
  {
    unit_type: "dataset",
    unit_name: "rag_dataset",
    model_name: undefined,
    feature_name: "rag",
    totalQuantity: 23.9,
    totalCost: 2390.0,
    attributes: { size_gb: "23.9" },
  },
];

// Example for groupBy: 'day' (nested structure) with higher values
export const mockDetailedUsageByDay = [
  {
    _id: "2025-04-27", // Most recent day
    totalCost: 35000.0,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 12500.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 25000000,
            cost: 75.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 50000000,
            cost: 750.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3.7-sonnet input_token",
            model_name: "claude-3.7-sonnet",
            feature_name: undefined,
            quantity: 23500000,
            cost: 141.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3.7-sonnet output_token",
            model_name: "claude-3.7-sonnet",
            feature_name: undefined,
            quantity: 21200000,
            cost: 636.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "bedrock_integration",
            model_name: undefined,
            feature_name: "bedrock_integration",
            quantity: 32000000,
            cost: 10898.0,
            attributes: { integration_type: "aws" },
          },
        ],
      },
      {
        platform_id: mockPlatformId4,
        platform_name: "gemini",
        totalCost: 8500.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gemini-1.5-ultra input_token",
            model_name: "gemini-1.5-ultra",
            feature_name: undefined,
            quantity: 22000000,
            cost: 220.0,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-ultra output_token",
            model_name: "gemini-1.5-ultra",
            feature_name: undefined,
            quantity: 16500000,
            cost: 495.0,
            attributes: { token_type: "output", prompt_size: "<=128k" },
          },
          {
            unit_type: "image",
            unit_name: "imagen_generation",
            model_name: "imagen",
            feature_name: "image_generation",
            quantity: 27500,
            cost: 7785.0,
            attributes: { resolution: "1024x1024" },
          },
        ],
      },
      {
        platform_id: mockPlatformId2,
        platform_name: "openAI",
        totalCost: 5200.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gpt-4o input_token",
            model_name: "gpt-4o",
            feature_name: undefined,
            quantity: 15400000,
            cost: 154.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-4o output_token",
            model_name: "gpt-4o",
            feature_name: undefined,
            quantity: 7700000,
            cost: 231.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "image",
            unit_name: "dall-e-3_image",
            model_name: "dall-e-3",
            feature_name: "image_generation",
            quantity: 41375,
            cost: 1655.0,
            attributes: { resolution: "1024x1024" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-4-turbo input_token",
            model_name: "gpt-4-turbo",
            feature_name: undefined,
            quantity: 13200000,
            cost: 396.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-4-turbo output_token",
            model_name: "gpt-4-turbo",
            feature_name: undefined,
            quantity: 7700000,
            cost: 462.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "minute",
            unit_name: "whisper_minute",
            model_name: "whisper",
            feature_name: "whisper",
            quantity: 387,
            cost: 38.7,
            attributes: {},
          },
          {
            unit_type: "token",
            unit_name: "gpt-3.5-turbo input_token",
            model_name: "gpt-3.5-turbo",
            feature_name: undefined,
            quantity: 38500000,
            cost: 19.25,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-3.5-turbo output_token",
            model_name: "gpt-3.5-turbo",
            feature_name: undefined,
            quantity: 23100000,
            cost: 34.65,
            attributes: { token_type: "output" },
          },
        ],
      },
      {
        platform_id: mockPlatformId1,
        platform_name: "tavily",
        totalCost: 4200.0,
        items: [
          {
            unit_type: "credit",
            unit_name: "basic_search_credit",
            model_name: undefined,
            feature_name: "basic_search",
            quantity: 385000,
            cost: 2887.5,
            attributes: { search_depth: "basic" },
          },
          {
            unit_type: "credit",
            unit_name: "advanced_search_credit",
            model_name: undefined,
            feature_name: "advanced_search",
            quantity: 115500,
            cost: 924.0,
            attributes: { search_depth: "advanced" },
          },
          {
            unit_type: "credit",
            unit_name: "document_processing_credit",
            model_name: undefined,
            feature_name: "document_processing",
            quantity: 7500,
            cost: 75.0,
            attributes: { processing_type: "pdf" },
          },
        ],
      },
      {
        platform_id: mockPlatformId7,
        platform_name: "replicate",
        totalCost: 1700.0,
        items: [
          {
            unit_type: "compute",
            unit_name: "prediction_compute",
            model_name: "stability-ai/sdxl",
            feature_name: "prediction",
            quantity: 27500,
            cost: 550.0,
            attributes: { hardware: "gpu" },
          },
          {
            unit_type: "compute",
            unit_name: "prediction_compute",
            model_name: "meta/llama-3-70b-instruct",
            feature_name: "prediction",
            quantity: 19250,
            cost: 385.0,
            attributes: { hardware: "gpu" },
          },
          {
            unit_type: "compute",
            unit_name: "training_compute",
            model_name: "custom-fine-tuning",
            feature_name: "training",
            quantity: 10230,
            cost: 511.5,
            attributes: { hardware: "gpu", instance_type: "A100" },
          },
          {
            unit_type: "compute",
            unit_name: "prediction_compute",
            model_name: "anthropic/claude-3-sonnet",
            feature_name: "prediction",
            quantity: 9350,
            cost: 187.0,
            attributes: { hardware: "gpu" },
          },
        ],
      },
      {
        platform_id: mockPlatformId8,
        platform_name: "cohere",
        totalCost: 1400.0,
        items: [
          {
            unit_type: "token",
            unit_name: "command-r input_token",
            model_name: "command-r",
            feature_name: undefined,
            quantity: 16500000,
            cost: 82.5,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "command-r output_token",
            model_name: "command-r",
            feature_name: undefined,
            quantity: 13200000,
            cost: 132.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "command-r-plus input_token",
            model_name: "command-r-plus",
            feature_name: undefined,
            quantity: 22000000,
            cost: 220.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "command-r-plus output_token",
            model_name: "command-r-plus",
            feature_name: undefined,
            quantity: 19800000,
            cost: 396.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "embed-english",
            model_name: "embed-english",
            feature_name: "embedding",
            quantity: 93500000,
            cost: 140.25,
            attributes: {},
          },
          {
            unit_type: "token",
            unit_name: "embed-multilingual",
            model_name: "embed-multilingual",
            feature_name: "embedding",
            quantity: 71500000,
            cost: 178.75,
            attributes: {},
          },
          {
            unit_type: "dataset",
            unit_name: "rag_dataset",
            model_name: undefined,
            feature_name: "rag",
            quantity: 2.5,
            cost: 250.0,
            attributes: { size_gb: "2.5" },
          },
        ],
      },
      {
        platform_id: mockPlatformId5,
        platform_name: "elevenlabs",
        totalCost: 1050.0,
        items: [
          {
            unit_type: "credit",
            unit_name: "text_to_speech_multilingual_credit",
            model_name: undefined,
            feature_name: "text_to_speech_multilingual",
            quantity: 3850000,
            cost: 346.5,
            attributes: { quality: "high" },
          },
          {
            unit_type: "credit",
            unit_name: "text_to_speech_flash_credit",
            model_name: undefined,
            feature_name: "text_to_speech_flash",
            quantity: 1540000,
            cost: 138.6,
            attributes: { quality: "low_latency" },
          },
          {
            unit_type: "credit",
            unit_name: "voice_design_credit",
            model_name: undefined,
            feature_name: "voice_design",
            quantity: 550000,
            cost: 110.0,
            attributes: { voice_type: "custom" },
          },
          {
            unit_type: "credit",
            unit_name: "voice_cloning_credit",
            model_name: undefined,
            feature_name: "voice_cloning",
            quantity: 140,
            cost: 420.0,
            attributes: { cloning_type: "professional" },
          },
        ],
      },
    ],
  },
  {
    _id: "2025-04-26", // Previous day
    totalCost: 31500.0,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 11250.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 22500000,
            cost: 67.5,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 45000000,
            cost: 675.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "bedrock_integration",
            model_name: undefined,
            feature_name: "bedrock_integration",
            quantity: 28800000,
            cost: 9800.0,
            attributes: { integration_type: "aws" },
          },
        ],
      },
      {
        platform_id: mockPlatformId2,
        platform_name: "openAI",
        totalCost: 4680.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gpt-4o input_token",
            model_name: "gpt-4o",
            feature_name: undefined,
            quantity: 13860000,
            cost: 138.6,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-4o output_token",
            model_name: "gpt-4o",
            feature_name: undefined,
            quantity: 6930000,
            cost: 207.9,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "image",
            unit_name: "dall-e-3_image",
            model_name: "dall-e-3",
            feature_name: "image_generation",
            quantity: 37240,
            cost: 1489.6,
            attributes: { resolution: "1024x1024" },
          },
        ],
      },
    ],
  },
];

// Example for groupBy: 'week' with higher costs
export const mockDetailedUsageByWeek = [
  {
    _id: "2025-W17", // Current week
    totalCost: 230000.0,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 72000.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 147000000,
            cost: 441.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 294000000,
            cost: 4410.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "bedrock_integration",
            model_name: undefined,
            feature_name: "bedrock_integration",
            quantity: 196000000,
            cost: 66800.0,
            attributes: { integration_type: "aws" },
          },
        ],
      },
      {
        platform_id: mockPlatformId4,
        platform_name: "gemini",
        totalCost: 45000.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash input_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 196000000,
            cost: 147.0,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash output_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 98000000,
            cost: 29.4,
            attributes: { token_type: "output", prompt_size: "<=128k" },
          },
          {
            unit_type: "image",
            unit_name: "imagen_generation",
            model_name: "imagen",
            feature_name: "image_generation",
            quantity: 175000,
            cost: 31500.0,
            attributes: { resolution: "1024x1024" },
          },
        ],
      },
      {
        platform_id: mockPlatformId1,
        platform_name: "tavily",
        totalCost: 25567.2,
        items: [
          {
            unit_type: "credit",
            unit_name: "basic_search_credit",
            model_name: undefined,
            feature_name: "basic_search",
            quantity: 2450000,
            cost: 18375.0,
            attributes: { search_depth: "basic" },
          },
          {
            unit_type: "credit",
            unit_name: "advanced_search_credit",
            model_name: undefined,
            feature_name: "advanced_search",
            quantity: 735000,
            cost: 5880.0,
            attributes: { search_depth: "advanced" },
          },
        ],
      },
    ],
  },
  {
    _id: "2025-W16", // Previous week
    totalCost: 210000.0,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 68000.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 140000000,
            cost: 420.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 280000000,
            cost: 4200.0,
            attributes: { token_type: "output" },
          },
        ],
      },
    ],
  },
];

export const mockDetailedUsageByMonth = [
  {
    _id: "2025-04", // Current month
    totalCost: 302251.75,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 97237.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 210000000,
            cost: 630.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 420000000,
            cost: 6300.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-opus input_token",
            model_name: "claude-3-opus",
            feature_name: undefined,
            quantity: 70000000,
            cost: 1050.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-opus output_token",
            model_name: "claude-3-opus",
            feature_name: undefined,
            quantity: 140000000,
            cost: 10500.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-haiku input_token",
            model_name: "claude-3-haiku",
            feature_name: undefined,
            quantity: 500000000,
            cost: 625.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-haiku output_token",
            model_name: "claude-3-haiku",
            feature_name: undefined,
            quantity: 350000000,
            cost: 1312.5,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3.7-sonnet input_token",
            model_name: "claude-3.7-sonnet",
            feature_name: undefined,
            quantity: 200000000,
            cost: 1200.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3.7-sonnet output_token",
            model_name: "claude-3.7-sonnet",
            feature_name: undefined,
            quantity: 180000000,
            cost: 5400.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "claude-2 input_token",
            model_name: "claude-2",
            feature_name: undefined,
            quantity: 350000000,
            cost: 280.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-2 output_token",
            model_name: "claude-2",
            feature_name: undefined,
            quantity: 320000000,
            cost: 768.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "prompt_caching_write",
            model_name: undefined,
            feature_name: "prompt_caching_write",
            quantity: 35000000,
            cost: 131.6,
            attributes: {},
          },
          {
            unit_type: "token",
            unit_name: "prompt_caching_read",
            model_name: undefined,
            feature_name: "prompt_caching_read",
            quantity: 70000000,
            cost: 21.0,
            attributes: {},
          },
          {
            unit_type: "token",
            unit_name: "bedrock_integration",
            model_name: undefined,
            feature_name: "bedrock_integration",
            quantity: 280000000,
            cost: 69018.9,
            attributes: { integration_type: "aws" },
          },
        ],
      },
      {
        platform_id: mockPlatformId4,
        platform_name: "gemini",
        totalCost: 52696.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash input_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 280000000,
            cost: 210.0,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash output_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 140000000,
            cost: 42.0,
            attributes: { token_type: "output", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-pro input_token",
            model_name: "gemini-1.5-pro",
            feature_name: undefined,
            quantity: 70000000,
            cost: 87.5,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-pro output_token",
            model_name: "gemini-1.5-pro",
            feature_name: undefined,
            quantity: 35000000,
            cost: 175.0,
            attributes: { token_type: "output", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-ultra input_token",
            model_name: "gemini-1.5-ultra",
            feature_name: undefined,
            quantity: 200000000,
            cost: 2000.0,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-ultra output_token",
            model_name: "gemini-1.5-ultra",
            feature_name: undefined,
            quantity: 150000000,
            cost: 4500.0,
            attributes: { token_type: "output", prompt_size: "<=128k" },
          },
          {
            unit_type: "image",
            unit_name: "imagen_generation",
            model_name: "imagen",
            feature_name: "image_generation",
            quantity: 250000,
            cost: 45000.0,
            attributes: { resolution: "1024x1024" },
          },
          {
            unit_type: "video",
            unit_name: "video_generation",
            model_name: "veo",
            feature_name: "video_generation",
            quantity: 1800,
            cost: 359.0,
            attributes: { resolution: "1080p", duration: "15s" },
          },
        ],
      },
      {
        platform_id: mockPlatformId1,
        platform_name: "tavily",
        totalCost: 37956.75,
        items: [
          {
            unit_type: "credit",
            unit_name: "basic_search_credit",
            model_name: undefined,
            feature_name: "basic_search",
            quantity: 3500000,
            cost: 26250.0,
            attributes: { search_depth: "basic" },
          },
          {
            unit_type: "credit",
            unit_name: "advanced_search_credit",
            model_name: undefined,
            feature_name: "advanced_search",
            quantity: 1050000,
            cost: 8400.0,
            attributes: { search_depth: "advanced" },
          },
          {
            unit_type: "credit",
            unit_name: "basic_extract_credit",
            model_name: undefined,
            feature_name: "basic_extract",
            quantity: 700000,
            cost: 2625.0,
            attributes: { extract_depth: "basic" },
          },
          {
            unit_type: "credit",
            unit_name: "document_processing_credit",
            model_name: undefined,
            feature_name: "document_processing",
            quantity: 68175,
            cost: 681.75,
            attributes: { processing_type: "pdf" },
          },
        ],
      },
      {
        platform_id: mockPlatformId2,
        platform_name: "openAI",
        totalCost: 27237.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gpt-3.5-turbo input_token",
            model_name: "gpt-3.5-turbo",
            feature_name: undefined,
            quantity: 350000000,
            cost: 175.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-3.5-turbo output_token",
            model_name: "gpt-3.5-turbo",
            feature_name: undefined,
            quantity: 210000000,
            cost: 315.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-4o input_token",
            model_name: "gpt-4o",
            feature_name: undefined,
            quantity: 140000000,
            cost: 1400.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "gpt-4o output_token",
            model_name: "gpt-4o",
            feature_name: undefined,
            quantity: 70000000,
            cost: 2100.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "image",
            unit_name: "dall-e-3_image",
            model_name: "dall-e-3",
            feature_name: "image_generation",
            quantity: 374750,
            cost: 14990.0,
            attributes: { resolution: "1024x1024" },
          },
        ],
      },
      {
        platform_id: mockPlatformId5,
        platform_name: "elevenlabs",
        totalCost: 29505.0,
        items: [
          {
            unit_type: "credit",
            unit_name: "text_to_speech_multilingual_credit",
            model_name: undefined,
            feature_name: "text_to_speech_multilingual",
            quantity: 35000000,
            cost: 3150.0,
            attributes: { quality: "high" },
          },
          {
            unit_type: "credit",
            unit_name: "text_to_speech_flash_credit",
            model_name: undefined,
            feature_name: "text_to_speech_flash",
            quantity: 14000000,
            cost: 1260.0,
            attributes: { quality: "low_latency" },
          },
          {
            unit_type: "credit",
            unit_name: "voice_cloning_credit",
            model_name: undefined,
            feature_name: "voice_cloning",
            quantity: 5750,
            cost: 17250.0,
            attributes: { cloning_type: "professional" },
          },
        ],
      },
      {
        platform_id: mockPlatformId7,
        platform_name: "replicate",
        totalCost: 15420.0,
        items: [
          {
            unit_type: "compute",
            unit_name: "prediction_compute",
            model_name: "stability-ai/sdxl",
            feature_name: "prediction",
            quantity: 250000,
            cost: 5000.0,
            attributes: { hardware: "gpu" },
          },
          {
            unit_type: "compute",
            unit_name: "prediction_compute",
            model_name: "meta/llama-3-70b-instruct",
            feature_name: "prediction",
            quantity: 175000,
            cost: 3500.0,
            attributes: { hardware: "gpu" },
          },
          {
            unit_type: "compute",
            unit_name: "training_compute",
            model_name: "custom-fine-tuning",
            feature_name: "training",
            quantity: 93000,
            cost: 4650.0,
            attributes: { hardware: "gpu", instance_type: "A100" },
          },
        ],
      },
      {
        platform_id: mockPlatformId8,
        platform_name: "cohere",
        totalCost: 12840.0,
        items: [
          {
            unit_type: "token",
            unit_name: "command-r input_token",
            model_name: "command-r",
            feature_name: undefined,
            quantity: 150000000,
            cost: 750.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "command-r output_token",
            model_name: "command-r",
            feature_name: undefined,
            quantity: 120000000,
            cost: 1200.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "command-r-plus input_token",
            model_name: "command-r-plus",
            feature_name: undefined,
            quantity: 200000000,
            cost: 2000.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "command-r-plus output_token",
            model_name: "command-r-plus",
            feature_name: undefined,
            quantity: 180000000,
            cost: 3600.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "dataset",
            unit_name: "rag_dataset",
            model_name: undefined,
            feature_name: "rag",
            quantity: 23.9,
            cost: 2390.0,
            attributes: { size_gb: "23.9" },
          },
        ],
      },
      {
        platform_id: mockPlatformId9,
        platform_name: "stability",
        totalCost: 9780.0,
        items: [
          {
            unit_type: "credit",
            unit_name: "standard_credit",
            model_name: "stable-diffusion-xl",
            feature_name: "image_generation",
            quantity: 127500,
            cost: 3825.0,
            attributes: { resolution: "1024x1024" },
          },
          {
            unit_type: "credit",
            unit_name: "standard_credit",
            model_name: "stable-video-diffusion",
            feature_name: "video_generation",
            quantity: 57800,
            cost: 4046.0,
            attributes: { seconds: "5" },
          },
        ],
      },
      {
        platform_id: mockPlatformId10,
        platform_name: "mistral",
        totalCost: 8730.0,
        items: [
          {
            unit_type: "token",
            unit_name: "mistral-small-latest input_token",
            model_name: "mistral-small-latest",
            feature_name: undefined,
            quantity: 295000000,
            cost: 590.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "mistral-small-latest output_token",
            model_name: "mistral-small-latest",
            feature_name: undefined,
            quantity: 250000000,
            cost: 1000.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "mistral-large-latest input_token",
            model_name: "mistral-large-latest",
            feature_name: undefined,
            quantity: 78500000,
            cost: 1570.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "mistral-large-latest output_token",
            model_name: "mistral-large-latest",
            feature_name: undefined,
            quantity: 68000000,
            cost: 2720.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "embedding",
            model_name: "mistral-embed",
            feature_name: "embedding",
            quantity: 850000000,
            cost: 850.0,
            attributes: {},
          },
        ],
      },
      {
        platform_id: mockPlatformId6,
        platform_name: "huggingface",
        totalCost: 10850.0,
        items: [
          {
            unit_type: "compute",
            unit_name: "inference_api_compute_gpu",
            model_name: "some-text-generation-model",
            feature_name: "inference_api",
            quantity: 252000,
            cost: 30.1,
            attributes: { hardware: "gpu" },
          },
          {
            unit_type: "compute",
            unit_name: "fine_tuning_compute",
            model_name: undefined,
            feature_name: "fine_tuning",
            quantity: 185000,
            cost: 9250.0,
            attributes: { hardware: "gpu", instance_type: "A100" },
          },
          {
            unit_type: "storage",
            unit_name: "model_storage_gb",
            model_name: undefined,
            feature_name: "model_storage",
            quantity: 8500,
            cost: 850.0,
            attributes: { storage_type: "standard" },
          },
        ],
      },
    ],
  },
  {
    _id: "2025-03", // Previous month
    totalCost: 470190.0,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 107023.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 231000000,
            cost: 693.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 462000000,
            cost: 6930.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-opus input_token",
            model_name: "claude-3-opus",
            feature_name: undefined,
            quantity: 77000000,
            cost: 1155.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-opus output_token",
            model_name: "claude-3-opus",
            feature_name: undefined,
            quantity: 154000000,
            cost: 11550.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "bedrock_integration",
            model_name: undefined,
            feature_name: "bedrock_integration",
            quantity: 308000000,
            cost: 75950.0,
            attributes: { integration_type: "aws" },
          },
        ],
      },
      {
        platform_id: mockPlatformId4,
        platform_name: "gemini",
        totalCost: 91000.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash input_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 308000000,
            cost: 231.0,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash output_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 154000000,
            cost: 46.2,
            attributes: { token_type: "output", prompt_size: "<=128k" },
          },
          {
            unit_type: "image",
            unit_name: "imagen_generation",
            model_name: "imagen",
            feature_name: "image_generation",
            quantity: 275000,
            cost: 49500.0,
            attributes: { resolution: "1024x1024" },
          },
        ],
      },
      {
        platform_id: mockPlatformId1,
        platform_name: "tavily",
        totalCost: 86131.5,
        items: [
          {
            unit_type: "credit",
            unit_name: "basic_search_credit",
            model_name: undefined,
            feature_name: "basic_search",
            quantity: 7700000,
            cost: 57750.0,
            attributes: { search_depth: "basic" },
          },
          {
            unit_type: "credit",
            unit_name: "advanced_search_credit",
            model_name: undefined,
            feature_name: "advanced_search",
            quantity: 2750000,
            cost: 22000.0,
            attributes: { search_depth: "advanced" },
          },
        ],
      },
    ],
  },
  {
    _id: "2025-02", // Two months ago
    totalCost: 413104.0,
    platforms: [
      {
        platform_id: mockPlatformId3,
        platform_name: "claude",
        totalCost: 94969.0,
        items: [
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet input_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 210000000,
            cost: 630.0,
            attributes: { token_type: "input" },
          },
          {
            unit_type: "token",
            unit_name: "claude-3-sonnet output_token",
            model_name: "claude-3-sonnet",
            feature_name: undefined,
            quantity: 420000000,
            cost: 6300.0,
            attributes: { token_type: "output" },
          },
          {
            unit_type: "token",
            unit_name: "bedrock_integration",
            model_name: undefined,
            feature_name: "bedrock_integration",
            quantity: 280000000,
            cost: 68800.0,
            attributes: { integration_type: "aws" },
          },
        ],
      },
      {
        platform_id: mockPlatformId4,
        platform_name: "gemini",
        totalCost: 80500.0,
        items: [
          {
            unit_type: "token",
            unit_name: "gemini-1.5-flash input_token",
            model_name: "gemini-1.5-flash",
            feature_name: undefined,
            quantity: 280000000,
            cost: 210.0,
            attributes: { token_type: "input", prompt_size: "<=128k" },
          },
          {
            unit_type: "image",
            unit_name: "imagen_generation",
            model_name: "imagen",
            feature_name: "image_generation",
            quantity: 250000,
            cost: 45000.0,
            attributes: { resolution: "1024x1024" },
          },
        ],
      },
    ],
  },
];

// Empty state with the updated structure and additional platforms
export const mockEmptyState = {
  platforms: [],
  summary: {
    totalPlatforms: 0,
    currentMonthUsage: {
      cost: 0.0,
      tokens: 0,
      requests: 0,
    },
    percentChange: 0,
    forecastedCost: 0.0,
  },
  trends: [],
  detailedUsage: [],
  detailedUsageByPlatform: [],
  detailedUsageByItem: [],
  detailedUsageByDay: [],
  detailedUsageByWeek: [],
  detailedUsageByMonth: [],
};

// Error state remains the same
export const mockErrorState = {
  error: "Failed to fetch dashboard data. Please try again later.",
};

// Loading states with additional entries for new data types
export const mockLoadingStates = {
  isLoadingSummary: true,
  isLoadingTrends: true,
  isLoadingPlatforms: true,
  isLoadingDetailedUsage: true,
  isLoadingComparison: true,
  isExporting: false,
  isLoadingPredictions: true, // Added for forecasting data
  isLoadingAlerts: true, // Added for alerts
  isLoadingRecommendations: true, // Added for cost optimization recommendations
};

// Additional mock data for new features

// Mock usage predictions for upcoming months
export const mockPredictions = {
  forecastedMonthlyCosts: [
    {
      month: "2025-05",
      predicted: 315000.0,
      lowerBound: 295000.0,
      upperBound: 335000.0,
    },
    {
      month: "2025-06",
      predicted: 325000.0,
      lowerBound: 300000.0,
      upperBound: 350000.0,
    },
    {
      month: "2025-07",
      predicted: 340000.0,
      lowerBound: 310000.0,
      upperBound: 370000.0,
    },
  ],
  anomalyProbability: 0.15, // Probability of exceeding upper bound
  potentialSavings: 45000.0, // Potential monthly savings from optimizations
};

// Mock alerts data
export const mockAlerts = [
  {
    id: "alert-001",
    type: "cost_threshold",
    severity: "high",
    message:
      "Claude spend exceeded daily threshold of $10,000 for 3 consecutive days",
    platformId: mockPlatformId3,
    platformName: "claude",
    timestamp: "2025-04-25T14:22:31Z",
    details: {
      threshold: 10000,
      actual: 12500,
      unit: "USD",
      period: "daily",
      consecutive: 3,
    },
    isRead: false,
  },
  {
    id: "alert-002",
    type: "usage_spike",
    severity: "medium",
    message: "Unusual increase in OpenAI DALL-E 3 usage (68% above normal)",
    platformId: mockPlatformId2,
    platformName: "openAI",
    timestamp: "2025-04-26T09:15:42Z",
    details: {
      modelName: "dall-e-3",
      percentIncrease: 68,
      normalUsage: { images: 22250, cost: 890.0 },
      currentUsage: { images: 37375, cost: 1495.0 },
      period: "daily",
    },
    isRead: true,
  },
  {
    id: "alert-003",
    type: "rate_limit",
    severity: "low",
    message:
      "Gemini API rate limit reached (100 requests/min) at 2025-04-26T16:45:22Z",
    platformId: mockPlatformId4,
    platformName: "gemini",
    timestamp: "2025-04-26T16:45:30Z",
    details: {
      limitType: "requests_per_minute",
      limit: 100,
      duration: "3 minutes",
      affectedService: "chat_completions",
    },
    isRead: false,
  },
  {
    id: "alert-004",
    type: "cost_forecast",
    severity: "medium",
    message: "April forecasted cost exceeds budget by 21%",
    platformId: null, // Null because it's across all platforms
    platformName: null,
    timestamp: "2025-04-22T00:05:12Z",
    details: {
      budget: 250000,
      forecast: 302251.75,
      overage: 52251.75,
      overagePercent: 21,
    },
    isRead: true,
  },
  {
    id: "alert-005",
    type: "api_error",
    severity: "high",
    message:
      "Replicate API experiencing high error rate (15% of requests failing)",
    platformId: mockPlatformId7,
    platformName: "replicate",
    timestamp: "2025-04-27T10:12:55Z",
    details: {
      errorRate: 15,
      normalRate: 2,
      errorCodes: ["429", "500", "503"],
      startTime: "2025-04-27T09:45:00Z",
      affectedModels: ["stability-ai/sdxl", "meta/llama-3-70b-instruct"],
    },
    isRead: false,
  },
];

// Mock optimization recommendations
export const mockRecommendations = [
  {
    id: "rec-001",
    type: "model_swap",
    title:
      "Switch from Claude-3-Opus to Claude-3-Sonnet for non-critical tasks",
    description:
      "Our analysis shows 35% of your Claude-3-Opus usage could use Claude-3-Sonnet with minimal quality difference, saving approximately $24,500 per month.",
    platformId: mockPlatformId3,
    platformName: "claude",
    potentialSavings: 24500,
    difficulty: "easy",
    impact: "high",
    details: {
      currentModel: "claude-3-opus",
      recommendedModel: "claude-3-sonnet",
      affectedRequests: 49000,
      qualityDifference: "minimal",
      implementationSteps: [
        "Identify non-critical workflows using Claude-3-Opus",
        "Modify API calls to use claude-3-sonnet model parameter",
        "Monitor output quality to ensure it meets requirements",
      ],
    },
  },
  {
    id: "rec-002",
    type: "prompt_optimization",
    title: "Optimize prompts to reduce token usage",
    description:
      "Reducing prompt verbosity and implementing better instruction techniques could reduce token consumption by 22%, saving approximately $15,800 per month across all platforms.",
    platformId: null,
    platformName: null,
    potentialSavings: 15800,
    difficulty: "medium",
    impact: "medium",
    details: {
      averagePromptLength: 850,
      recommendedPromptLength: 650,
      tokenReduction: "22%",
      implementationSteps: [
        "Audit current prompt templates",
        "Remove redundant instructions and context",
        "Implement few-shot examples more efficiently",
        "Use system prompts where available",
      ],
    },
  },
  {
    id: "rec-003",
    type: "caching",
    title: "Implement response caching for OpenAI completions",
    description:
      "Implementing a caching layer for common queries could reduce API calls by 28%, saving approximately $7,600 per month.",
    platformId: mockPlatformId2,
    platformName: "openAI",
    potentialSavings: 7600,
    difficulty: "medium",
    impact: "medium",
    details: {
      repeatQueryRate: "28%",
      cacheTTL: "24 hours",
      implementationSteps: [
        "Set up Redis or similar caching infrastructure",
        "Implement hash-based lookup for similar queries",
        "Configure appropriate time-to-live settings",
        "Implement cache invalidation strategy",
      ],
    },
  },
  {
    id: "rec-004",
    type: "version_upgrade",
    title: "Upgrade to GPT-4o from GPT-4-Turbo",
    description:
      "GPT-4o offers equivalent or better performance at lower cost compared to GPT-4-Turbo, potentially saving $4,200 per month.",
    platformId: mockPlatformId2,
    platformName: "openAI",
    potentialSavings: 4200,
    difficulty: "easy",
    impact: "medium",
    details: {
      currentModel: "gpt-4-turbo",
      recommendedModel: "gpt-4o",
      costDifference: "15% lower",
      performanceImpact: "equivalent or improved",
      implementationSteps: [
        "Replace 'gpt-4-turbo' with 'gpt-4o' in API calls",
        "Test performance on key workflows",
        "Monitor latency and throughput",
      ],
    },
  },
  {
    id: "rec-005",
    type: "usage_quota",
    title: "Implement usage quotas for image generation",
    description:
      "Setting daily usage limits on DALL-E 3 and Stability image generation could save approximately $8,900 per month by preventing unnecessary overuse.",
    platformId: null,
    platformName: null,
    potentialSavings: 8900,
    difficulty: "hard",
    impact: "high",
    details: {
      affectedPlatforms: ["openAI", "stability", "gemini"],
      recommendedQuotas: {
        daily: 1000,
        user: 50,
        project: 200,
      },
      implementationSteps: [
        "Develop quota tracking system",
        "Implement rate limiting middleware",
        "Create approval workflow for quota exceptions",
        "Set up alerts for approaching quota limits",
      ],
    },
  },
];

// Mock feature usage analysis
export const mockFeatureUsage = {
  topFeatures: [
    { name: "text_generation", requests: 8500000, cost: 138500.0 },
    { name: "image_generation", requests: 650000, cost: 53250.0 },
    { name: "embeddings", requests: 4200000, cost: 4250.0 },
    { name: "search", requests: 5250000, cost: 37850.0 },
    { name: "voice_generation", requests: 850000, cost: 29300.0 },
  ],
  featureGrowth: [
    {
      name: "image_generation",
      growthRate: 68,
      previousCost: 31700.0,
      currentCost: 53250.0,
    },
    {
      name: "voice_generation",
      growthRate: 45,
      previousCost: 20200.0,
      currentCost: 29300.0,
    },
    {
      name: "fine_tuning",
      growthRate: 32,
      previousCost: 10500.0,
      currentCost: 13860.0,
    },
    {
      name: "text_generation",
      growthRate: 18,
      previousCost: 117350.0,
      currentCost: 138500.0,
    },
    {
      name: "embeddings",
      growthRate: 12,
      previousCost: 3790.0,
      currentCost: 4250.0,
    },
  ],
  costPerRequest: [
    { name: "fine_tuning", averageCost: 0.115 },
    { name: "image_generation", averageCost: 0.082 },
    { name: "voice_generation", averageCost: 0.034 },
    { name: "video_generation", averageCost: 0.031 },
    { name: "text_generation", averageCost: 0.016 },
  ],
};

// Mock model performance metrics
export const mockModelPerformance = {
  responseTime: [
    {
      model: "claude-3-opus",
      averageTime: 2850,
      p95Time: 4200,
      requests: 350000,
    },
    { model: "gpt-4o", averageTime: 1950, p95Time: 3100, requests: 420000 },
    {
      model: "claude-3-sonnet",
      averageTime: 1750,
      p95Time: 2800,
      requests: 620000,
    },
    {
      model: "gemini-1.5-pro",
      averageTime: 1650,
      p95Time: 2700,
      requests: 280000,
    },
    {
      model: "gpt-3.5-turbo",
      averageTime: 950,
      p95Time: 1600,
      requests: 1300000,
    },
  ],
  errorRates: [
    { model: "mistral-large-latest", rate: 2.2, requests: 350000 },
    { model: "claude-3-opus", rate: 1.8, requests: 350000 },
    { model: "gpt-4o", rate: 1.5, requests: 420000 },
    { model: "gemini-1.5-flash", rate: 1.2, requests: 750000 },
    { model: "gpt-3.5-turbo", rate: 0.9, requests: 1300000 },
  ],
  costEfficiency: [
    { model: "gpt-3.5-turbo", tokensPerDollar: 7500000 },
    { model: "gemini-1.5-flash", tokensPerDollar: 5000000 },
    { model: "claude-3-haiku", tokensPerDollar: 1750000 },
    { model: "mistral-small-latest", tokensPerDollar: 1250000 },
    { model: "claude-3-sonnet", tokensPerDollar: 750000 },
  ],
};

// Mock application/project-specific usage data
export const mockProjectUsage = [
  {
    id: "proj-001",
    name: "Customer Support Bot",
    totalCost: 47250.0,
    platforms: [
      {
        name: "claude",
        cost: 28750.0,
        models: ["claude-3-sonnet", "claude-3-haiku"],
      },
      { name: "openAI", cost: 8500.0, models: ["gpt-3.5-turbo", "whisper"] },
      {
        name: "elevenlabs",
        cost: 10000.0,
        features: ["text_to_speech_multilingual"],
      },
    ],
    metrics: {
      conversations: 85000,
      averageCostPerConversation: 0.556,
      costTrend: -3.5, // Percentage change from previous period
    },
  },
  {
    id: "proj-002",
    name: "Content Creation Suite",
    totalCost: 73500.0,
    platforms: [
      { name: "openAI", cost: 32500.0, models: ["gpt-4o", "dall-e-3"] },
      { name: "gemini", cost: 25500.0, models: ["gemini-1.5-ultra", "imagen"] },
      {
        name: "stability",
        cost: 8250.0,
        features: ["image_generation", "image_editing"],
      },
      {
        name: "elevenlabs",
        cost: 7250.0,
        features: ["text_to_speech_multilingual", "voice_cloning"],
      },
    ],
    metrics: {
      contentPieces: 12500,
      averageCostPerPiece: 5.88,
      costTrend: 7.2, // Percentage change from previous period
    },
  },
  {
    id: "proj-003",
    name: "Research Assistant",
    totalCost: 63750.0,
    platforms: [
      {
        name: "tavily",
        cost: 28500.0,
        features: ["basic_search", "advanced_search"],
      },
      {
        name: "claude",
        cost: 21750.0,
        models: ["claude-3-opus", "claude-3-sonnet"],
      },
      { name: "openAI", cost: 8500.0, models: ["gpt-4o"] },
      { name: "cohere", cost: 5000.0, features: ["embed-multilingual", "rag"] },
    ],
    metrics: {
      searches: 215000,
      documents: 42500,
      averageCostPerSearch: 0.296,
      costTrend: 12.5, // Percentage change from previous period
    },
  },
  {
    id: "proj-004",
    name: "Code Assistant",
    totalCost: 52250.0,
    platforms: [
      { name: "openAI", cost: 30500.0, models: ["gpt-4o", "gpt-4-turbo"] },
      { name: "claude", cost: 15750.0, models: ["claude-3-opus"] },
      { name: "mistral", cost: 6000.0, models: ["mistral-large-latest"] },
    ],
    metrics: {
      codeCompletions: 320000,
      averageCostPerCompletion: 0.163,
      costTrend: -1.8, // Percentage change from previous period
    },
  },
  {
    id: "proj-005",
    name: "Multimedia Generation",
    totalCost: 34500.0,
    platforms: [
      {
        name: "stability",
        cost: 12500.0,
        features: ["image_generation", "video_generation"],
      },
      {
        name: "gemini",
        cost: 9500.0,
        features: ["imagen_generation", "video_generation"],
      },
      { name: "openAI", cost: 8500.0, models: ["dall-e-3"] },
      { name: "replicate", cost: 4000.0, models: ["stability-ai/sdxl"] },
    ],
    metrics: {
      imagesGenerated: 58000,
      videosGenerated: 2800,
      averageCostPerAsset: 0.567,
      costTrend: 22.5, // Percentage change from previous period
    },
  },
];

// Mock data for API cost breakdown
export const mockApiCostBreakdown = {
  byEndpoint: [
    { endpoint: "/v1/chat/completions", requests: 4250000, cost: 105750.0 },
    { endpoint: "/v1/images/generations", requests: 525000, cost: 42500.0 },
    { endpoint: "/v1/embeddings", requests: 3750000, cost: 11250.0 },
    { endpoint: "/v1/audio/speech", requests: 685000, cost: 27400.0 },
    { endpoint: "/v1/audio/transcriptions", requests: 12500, cost: 1250.0 },
  ],
  byStatusCode: [
    { code: 200, count: 8950000, percentage: 94.2 },
    { code: 429, count: 285000, percentage: 3.0 },
    { code: 400, count: 142500, percentage: 1.5 },
    { code: 500, count: 95000, percentage: 1.0 },
    { code: 503, count: 28500, percentage: 0.3 },
  ],
  byUserAgent: [
    { agent: "python-requests/2.28.2", requests: 4750000, cost: 95000.0 },
    { agent: "node-fetch/3.3.1", requests: 3250000, cost: 65000.0 },
    { agent: "axios/1.4.0", requests: 1250000, cost: 25000.0 },
    { agent: "curl/7.88.1", requests: 475000, cost: 9500.0 },
    { agent: "langchain/0.1.2", requests: 275000, cost: 5500.0 },
  ],
};

// Using string representations of ObjectIds for frontend mock data
export const mockUsageId1 = "65a7b1c2d3e4f5a6b7c8d9e0";
export const mockUsageId2 = "65a7b1c2d3e4f5a6b7c8d9e1";
export const mockUsageId3 = "65a7b1c2d3e4f5a6b7c8d9e2";
export const mockUsageId4 = "65a7b1c2d3e4f5a6b7c8d9e3";
export const mockUsageId5 = "65a7b1c2d3e4f5a6b7c8d9e4";
export const mockUsageId6 = "65a7b1c2d3e4f5a6b7c8d9e5";
export const mockUsageId7 = "65a7b1c2d3e4f5a6b7c8d9e6";
export const mockUsageId8 = "65a7b1c2d3e4f5a6b7c8d9e7";
export const mockUsageId9 = "65a7b1c2d3e4f5a6b7c8d9e8";
export const mockUsageId10 = "65a7b1c2d3e4f5a6b7c8d9e9";

// Mock usage data (aligned with UsageSchema fields relevant to frontend)
export const mockUsageRecords = [
  {
    _id: mockUsageId1,
    user_id: mockUserId,
    platform_id: mockPlatformId1,
    platform_name: "tavily",
    date: "2025-04-27T00:00:00.000Z",
    total_cost: 4200.0,
    usage_items: [
      {
        unit_type: "credit",
        unit_name: "basic_search_credit",
        model_name: undefined,
        feature_name: "basic_search",
        quantity: 385000,
        rate_per_unit: 0.0075,
        item_cost: 2887.5,
        attributes: { search_depth: "basic" },
      },
      {
        unit_type: "credit",
        unit_name: "advanced_search_credit",
        model_name: undefined,
        feature_name: "advanced_search",
        quantity: 115500,
        rate_per_unit: 0.008,
        item_cost: 924.0,
        attributes: { search_depth: "advanced" },
      },
      {
        unit_type: "credit",
        unit_name: "document_processing_credit",
        model_name: undefined,
        feature_name: "document_processing",
        quantity: 7500,
        rate_per_unit: 0.01,
        item_cost: 75.0,
        attributes: { processing_type: "pdf" },
      },
    ],
    createdAt: "2025-04-27T12:30:45.000Z",
    updatedAt: "2025-04-27T12:30:45.000Z",
  },
  {
    _id: mockUsageId2,
    user_id: mockUserId,
    platform_id: mockPlatformId2,
    platform_name: "openAI",
    date: "2025-04-27T00:00:00.000Z",
    total_cost: 5200.0,
    usage_items: [
      {
        unit_type: "token",
        unit_name: "gpt-4o input_token",
        model_name: "gpt-4o",
        feature_name: undefined,
        quantity: 15400000,
        rate_per_unit: 0.00001,
        item_cost: 154.0,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "gpt-4o output_token",
        model_name: "gpt-4o",
        feature_name: undefined,
        quantity: 7700000,
        rate_per_unit: 0.00003,
        item_cost: 231.0,
        attributes: { token_type: "output" },
      },
      {
        unit_type: "image",
        unit_name: "dall-e-3_image",
        model_name: "dall-e-3",
        feature_name: "image_generation",
        quantity: 41375,
        rate_per_unit: 0.04,
        item_cost: 1655.0,
        attributes: { resolution: "1024x1024" },
      },
    ],
    createdAt: "2025-04-27T14:15:23.000Z",
    updatedAt: "2025-04-27T14:15:23.000Z",
  },
  {
    _id: mockUsageId3,
    user_id: mockUserId,
    platform_id: mockPlatformId3,
    platform_name: "claude",
    date: "2025-04-27T00:00:00.000Z",
    total_cost: 12500.0,
    usage_items: [
      {
        unit_type: "token",
        unit_name: "claude-3-sonnet input_token",
        model_name: "claude-3-sonnet",
        feature_name: undefined,
        quantity: 25000000,
        rate_per_unit: 0.000003,
        item_cost: 75.0,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "claude-3-sonnet output_token",
        model_name: "claude-3-sonnet",
        feature_name: undefined,
        quantity: 50000000,
        rate_per_unit: 0.000015,
        item_cost: 750.0,
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "bedrock_integration",
        model_name: undefined,
        feature_name: "bedrock_integration",
        quantity: 32000000,
        rate_per_unit: 0.00034,
        item_cost: 10898.0,
        attributes: { integration_type: "aws" },
      },
    ],
    createdAt: "2025-04-27T15:42:18.000Z",
    updatedAt: "2025-04-27T15:42:18.000Z",
  },
  {
    _id: mockUsageId4,
    user_id: mockUserId,
    platform_id: mockPlatformId4,
    platform_name: "gemini",
    date: "2025-04-27T00:00:00.000Z",
    total_cost: 8500.0,
    usage_items: [
      {
        unit_type: "token",
        unit_name: "gemini-1.5-ultra input_token",
        model_name: "gemini-1.5-ultra",
        feature_name: undefined,
        quantity: 22000000,
        rate_per_unit: 0.00001,
        item_cost: 220.0,
        attributes: { token_type: "input", prompt_size: "<=128k" },
      },
      {
        unit_type: "token",
        unit_name: "gemini-1.5-ultra output_token",
        model_name: "gemini-1.5-ultra",
        feature_name: undefined,
        quantity: 16500000,
        rate_per_unit: 0.00003,
        item_cost: 495.0,
        attributes: { token_type: "output", prompt_size: "<=128k" },
      },
      {
        unit_type: "image",
        unit_name: "imagen_generation",
        model_name: "imagen",
        feature_name: "image_generation",
        quantity: 27500,
        rate_per_unit: 0.283,
        item_cost: 7785.0,
        attributes: { resolution: "1024x1024" },
      },
    ],
    createdAt: "2025-04-27T16:20:57.000Z",
    updatedAt: "2025-04-27T16:20:57.000Z",
  },
  {
    _id: mockUsageId5,
    user_id: mockUserId,
    platform_id: mockPlatformId5,
    platform_name: "elevenlabs",
    date: "2025-04-26T00:00:00.000Z",
    total_cost: 1050.0,
    usage_items: [
      {
        unit_type: "credit",
        unit_name: "text_to_speech_multilingual_credit",
        model_name: undefined,
        feature_name: "text_to_speech_multilingual",
        quantity: 3850000,
        rate_per_unit: 0.00009,
        item_cost: 346.5,
        attributes: { quality: "high" },
      },
      {
        unit_type: "credit",
        unit_name: "text_to_speech_flash_credit",
        model_name: undefined,
        feature_name: "text_to_speech_flash",
        quantity: 1540000,
        rate_per_unit: 0.00009,
        item_cost: 138.6,
        attributes: { quality: "low_latency" },
      },
      {
        unit_type: "credit",
        unit_name: "voice_cloning_credit",
        model_name: undefined,
        feature_name: "voice_cloning",
        quantity: 140,
        rate_per_unit: 3.0,
        item_cost: 420.0,
        attributes: { cloning_type: "professional" },
      },
    ],
    createdAt: "2025-04-26T22:10:33.000Z",
    updatedAt: "2025-04-26T22:10:33.000Z",
  },
  {
    _id: mockUsageId6,
    user_id: mockUserId,
    platform_id: mockPlatformId6,
    platform_name: "huggingface",
    date: "2025-04-26T00:00:00.000Z",
    total_cost: 10850.0,
    usage_items: [
      {
        unit_type: "compute",
        unit_name: "inference_api_compute_gpu",
        model_name: "some-text-generation-model",
        feature_name: "inference_api",
        quantity: 252000,
        rate_per_unit: 0.000119444, // Calculated to match item_cost
        item_cost: 30.1, // Scaled up from 0.43
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "inference_api_compute_cpu",
        model_name: "some-embedding-model",
        feature_name: "inference_api",
        quantity: 504000,
        rate_per_unit: 0.00005, // Calculated to match item_cost
        item_cost: 25.2, // Scaled up from 0.36
        attributes: { hardware: "cpu" },
      },
      {
        unit_type: "compute",
        unit_name: "inference_api_compute_gpu",
        model_name: "llama-70b",
        feature_name: "inference_api",
        quantity: 750000,
        rate_per_unit: 0.0005, // Calculated to match item_cost
        item_cost: 375.0, // New item
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "fine_tuning_compute",
        model_name: undefined,
        feature_name: "fine_tuning",
        quantity: 185000,
        rate_per_unit: 0.05, // Calculated to match item_cost
        item_cost: 9250.0, // New item
        attributes: { hardware: "gpu", instance_type: "A100" },
      },
      {
        unit_type: "storage",
        unit_name: "model_storage_gb",
        model_name: undefined,
        feature_name: "model_storage",
        quantity: 8500,
        rate_per_unit: 0.1, // Calculated to match item_cost
        item_cost: 850.0, // New item
        attributes: { storage_type: "standard" },
      },
      {
        unit_type: "request",
        unit_name: "inference_widget_request",
        model_name: undefined,
        feature_name: "inference_widget",
        quantity: 35000,
        rate_per_unit: 0.0, // Free service
        item_cost: 0.0, // Scaled up from 0.0
        attributes: {},
      },
      {
        unit_type: "compute",
        unit_name: "spaces_compute",
        model_name: undefined,
        feature_name: "spaces",
        quantity: 4000,
        rate_per_unit: 0.079925, // Calculated to match item_cost
        item_cost: 319.7, // New item
        attributes: { hardware: "gpu", instance_type: "T4" },
      },
    ],
    createdAt: "2025-04-26T23:45:12.000Z",
    updatedAt: "2025-04-26T23:45:12.000Z",
  },
  {
    _id: mockUsageId7,
    user_id: mockUserId,
    platform_id: mockPlatformId7,
    platform_name: "replicate",
    date: "2025-04-26T00:00:00.000Z",
    total_cost: 1700.0,
    usage_items: [
      {
        unit_type: "compute",
        unit_name: "prediction_compute",
        model_name: "stability-ai/sdxl",
        feature_name: "prediction",
        quantity: 27500,
        rate_per_unit: 0.02,
        item_cost: 550.0,
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "prediction_compute",
        model_name: "meta/llama-3-70b-instruct",
        feature_name: "prediction",
        quantity: 19250,
        rate_per_unit: 0.02,
        item_cost: 385.0,
        attributes: { hardware: "gpu" },
      },
      {
        unit_type: "compute",
        unit_name: "training_compute",
        model_name: "custom-fine-tuning",
        feature_name: "training",
        quantity: 10230,
        rate_per_unit: 0.05,
        item_cost: 511.5,
        attributes: { hardware: "gpu", instance_type: "A100" },
      },
      {
        unit_type: "compute",
        unit_name: "prediction_compute",
        model_name: "anthropic/claude-3-sonnet",
        feature_name: "prediction",
        quantity: 9350,
        rate_per_unit: 0.02,
        item_cost: 187.0,
        attributes: { hardware: "gpu" },
      },
    ],
    createdAt: "2025-04-26T21:30:42.000Z",
    updatedAt: "2025-04-26T21:30:42.000Z",
  },
  {
    _id: mockUsageId8,
    user_id: mockUserId,
    platform_id: mockPlatformId8,
    platform_name: "cohere",
    date: "2025-04-26T00:00:00.000Z",
    total_cost: 1400.0,
    usage_items: [
      {
        unit_type: "token",
        unit_name: "command-r input_token",
        model_name: "command-r",
        feature_name: undefined,
        quantity: 16500000,
        rate_per_unit: 0.000005,
        item_cost: 82.5,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "command-r output_token",
        model_name: "command-r",
        feature_name: undefined,
        quantity: 13200000,
        rate_per_unit: 0.00001,
        item_cost: 132.0,
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "command-r-plus input_token",
        model_name: "command-r-plus",
        feature_name: undefined,
        quantity: 22000000,
        rate_per_unit: 0.00001,
        item_cost: 220.0,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "command-r-plus output_token",
        model_name: "command-r-plus",
        feature_name: undefined,
        quantity: 19800000,
        rate_per_unit: 0.00002,
        item_cost: 396.0,
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "embed-english",
        model_name: "embed-english",
        feature_name: "embedding",
        quantity: 93500000,
        rate_per_unit: 0.0000015,
        item_cost: 140.25,
        attributes: {},
      },
      {
        unit_type: "dataset",
        unit_name: "rag_dataset",
        model_name: undefined,
        feature_name: "rag",
        quantity: 2.5,
        rate_per_unit: 100.0,
        item_cost: 250.0,
        attributes: { size_gb: "2.5" },
      },
    ],
    createdAt: "2025-04-26T20:18:05.000Z",
    updatedAt: "2025-04-26T20:18:05.000Z",
  },
  {
    _id: mockUsageId9,
    user_id: mockUserId,
    platform_id: mockPlatformId9,
    platform_name: "stability",
    date: "2025-04-25T00:00:00.000Z",
    total_cost: 1150.0,
    usage_items: [
      {
        unit_type: "credit",
        unit_name: "standard_credit",
        model_name: "stable-diffusion-xl",
        feature_name: "image_generation",
        quantity: 15000,
        rate_per_unit: 0.03,
        item_cost: 450.0,
        attributes: { resolution: "1024x1024" },
      },
      {
        unit_type: "credit",
        unit_name: "standard_credit",
        model_name: "stable-video-diffusion",
        feature_name: "video_generation",
        quantity: 7000,
        rate_per_unit: 0.07,
        item_cost: 490.0,
        attributes: { seconds: "5" },
      },
      {
        unit_type: "credit",
        unit_name: "inpainting_credit",
        model_name: "stable-diffusion-xl-inpainting",
        feature_name: "image_editing",
        quantity: 4200,
        rate_per_unit: 0.05,
        item_cost: 210.0,
        attributes: {},
      },
    ],
    createdAt: "2025-04-25T23:55:18.000Z",
    updatedAt: "2025-04-25T23:55:18.000Z",
  },
  {
    _id: mockUsageId10,
    user_id: mockUserId,
    platform_id: mockPlatformId10,
    platform_name: "mistral",
    date: "2025-04-25T00:00:00.000Z",
    total_cost: 1050.0,
    usage_items: [
      {
        unit_type: "token",
        unit_name: "mistral-small-latest input_token",
        model_name: "mistral-small-latest",
        feature_name: undefined,
        quantity: 36000000,
        rate_per_unit: 0.000002,
        item_cost: 72.0,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "mistral-small-latest output_token",
        model_name: "mistral-small-latest",
        feature_name: undefined,
        quantity: 30000000,
        rate_per_unit: 0.000004,
        item_cost: 120.0,
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "mistral-large-latest input_token",
        model_name: "mistral-large-latest",
        feature_name: undefined,
        quantity: 9500000,
        rate_per_unit: 0.00002,
        item_cost: 190.0,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "mistral-large-latest output_token",
        model_name: "mistral-large-latest",
        feature_name: undefined,
        quantity: 8250000,
        rate_per_unit: 0.00004,
        item_cost: 330.0,
        attributes: { token_type: "output" },
      },
      {
        unit_type: "token",
        unit_name: "embedding",
        model_name: "mistral-embed",
        feature_name: "embedding",
        quantity: 103000000,
        rate_per_unit: 0.000001,
        item_cost: 103.0,
        attributes: {},
      },
      {
        unit_type: "token",
        unit_name: "mixtral-8x7b input_token",
        model_name: "mixtral-8x7b",
        feature_name: undefined,
        quantity: 18000000,
        rate_per_unit: 0.000005,
        item_cost: 90.0,
        attributes: { token_type: "input" },
      },
      {
        unit_type: "token",
        unit_name: "mixtral-8x7b output_token",
        model_name: "mixtral-8x7b",
        feature_name: undefined,
        quantity: 15000000,
        rate_per_unit: 0.00001,
        item_cost: 150.0,
        attributes: { token_type: "output" },
      },
    ],
    createdAt: "2025-04-25T22:40:31.000Z",
    updatedAt: "2025-04-25T22:40:31.000Z",
  },
];

// Pagination data example for usage records
export const mockUsagePagination = {
  total: 48, // Total number of usage records
  page: 1, // Current page
  limit: 10, // Items per page
  pages: 5, // Total number of pages
};

// Mock error responses for usage operations
export const mockUsageErrors = {
  notFound: {
    error: "Usage record not found",
  },
  validationFailure: {
    error: "Validation failed",
    details: "Unit type is required for all items",
  },
  platformNotFound: {
    error: "Platform not found or does not belong to user",
  },
  duplicateEntry: {
    error:
      "A usage record for this platform and date already exists. Use update instead.",
  },
  unauthorized: {
    error: "Unauthorized access to usage data",
  },
};
